iOrgRowWidth = 0 // 原始行的宽度、0为自适应
var isPagepaces = true // 默认值空值
var IsPagetion = false
var iOrgFontSize = 21 // 原始字符的大小
var iRowWidth = iOrgRowWidth 	// 行宽
var iFontSize = iOrgFontSize 	// 正常的字体显示
var fScale = 1.0 		// 当前显示比例
var iMinRows = 7 		// 最小行数，即当一页中的行数小于此数时，则加上一些空行，如果设置为0，则表示按照实际行数显示
var iBTScale = 2 		// 标题字段显示的比例（以小字为单位）
var iTBScale = 1.3 	// 图标字段显示的比例（以小字为单位）
var iTSScale = 1.3 	// 图说字段显示的比例（以小字为单位）
var iSMScale = 2 		// 书名字段显示的比例（以小字为单位）
var isMinCaleBs = 0.8 // 超出字(比例)，调整间距
var g_nClicked = 3

var v = '3.0.0.9'
var pageheightwords = 0 // 一页中一行能占的总字数
var version = 0 // 显示数据的版本号
var unit = 0 // 显示数据的平均单位（ts_bs）
var iShowBookName = 1 // 是否显示书脊，１：显示，０：不显示
var arrayRows = new Array() 	// 保存XML中的每一行
var objDivRebuildPage // 显示页面DIV
var iPageNo 		// 当前页号
var iTotalPages 	// 当前书的总页数
var sCurPath 		// 当前文件所在在目录
var sCurInsetPath 	// 当前插图所在目录
var sJustFn 		// 当前文件的文件名（不含路径及扩展名）

var iZaoZiCount = 0 	// 造字计数
var irunlist = new Array() // 括号中字的集合
var sTopImage, sBottomImage // 顶部和底部图像

// 从XML文件中读取的参数
var iImageWidth, iImageHeight 	// 图像宽度和高度
var iTxtLeft, iTxtTop, iTxtRight, iTxtBottom // 文字区域坐标
var iThisLines, iThisHeightWords // 当前页面的行数，最长行的字数
var iMinLines 		// 最小行数
var iMaxLines 		// 最大行数
var iMaxHeightWords // 最长的行的字数（大字）
var itopline = -1, ibottomline = -1 // 页面红框的顶部距离、和底部距离
var itopMinLine = 30
var mimrowCounts = 6 // 最小行数

var xImageWidth = 0, xImageHeight = 0 	// 显示图像宽度和高度
var Imgs_scale, isregit = false // 显示比例数据图像的显示比例、是否放大缩小
var ItextHeightpages = 0, ItextHeightpage = 0, ItextToppage = 0, ItextLeftpage = 0 // 显示页面高度、显示框的高度；ItextHeightpages
var etextHeightpages, etextHeightpage, etextToppage, etextLeftpage
var Divdistance = 5 // 大行与小行的距离
var DivRowCount = 0 // 需要显示的总行数
var DivButtomLine = 50, DivTopLine = 65 // 边框底部的限制；
var IsPostMananger = true // 打开自动填充宽度;
var txMaxSize = 0 // 一行最多的字数;
var xMinRowWidth = 38, xMaxRowWidth = 300, isbottom = false // 最小的行宽、  最大的行宽  文本是否到达底部
var Fonz_scale = 0 // 放大缩小的倍数百分比
var iFontsid = 0 // 具体某一个字的id;
var iRowtsid = 0 // 大行小行的id
var iFontsids = 0 // 具体某一个字的id;
var iRowtsids = 0 // 大行小行的id
var tbCount = 0
var isFieleTe = false, leftToLine = 0 // 书名文字处理
var istextw = 0 // 双小字的（）判断分析。
var IpRowpos = 0 // 超行处理;
var isBackfor = false // 判断是否是封面
var cTurnRedFt = '' // 关键词检索
var aspectratio = -1 // 小字的间距调整：比例(xml的数据)
var nextreadNo = 0 // 一行中括号占的位置
var aspectrations = -1 // 计算出来的调整：
var TURNHEAD = '', TURNTAIL = '' // 跨页检索的词
var aspectHeight = 0 // 具体字的高度
var toArrayitspaces = 0 // 记录全局的缩放比例（小字）
var toArrayitspacNo = 0 // 记录全局的缩放比例（大字）
var tocountses = 0, tocountsNo = 0 // 记录全局小字（大字）的bs;
var MaxButtomHe = 0, aspectHeightpe = 0
var page = ''
var imageUrl = ''

// 根据页号加载XML文件，生成的内容保存到div中
function LoadPageXML (nPageNo, sDivId, nBzd) {
  objDivRebuildPage = document.getElementById('sDivId')
  $(objDivRebuildPage).empty() // 清空原来的内容
  arrayRows = [] // 清空数组
  iTotalPages = nLast
  iPageNo = nPageNo
  if (cTurnRed != '') {
    if (cTurnRed.indexOf('%') > -1) {
      cTurnRed = decodeURIComponent(cTurnRed)
    }
    cTurnFt = s2t(cTurnRed) // 简体转繁体
    cTurnRedFt = cTurnFt
    if (cTurnFt != cTurnRed) { cTurnRedFt = cTurnFt + '|' + cTurnRed }
  }
  // 获取该页的XML文件名
  imgSrc = ''
  if (sGrp == 'vips' && nPageNo > 9) { // vip收费用户，10页之后的计费，前10页默认正常显示
    imgSrc = GetImgSrc(nPageNo)
    if (imgSrc.length == 0) {
      // 默认显示第10页
      // return
      imgSrc = pic_array[9]
    }
  } else { imgSrc = pic_array[nPageNo] }

  var sXmlFn = cImg + imgSrc
  sJustFn = sXmlFn.substr(0, sXmlFn.length - 4)
  sXmlFn = sXmlFn.substr(0, sXmlFn.length - 3) + 'xml'
  sCurPath = sXmlFn
  iPos = sCurPath.lastIndexOf('/')
  if (iPos >= 0) { sCurPath = sCurPath.substr(0, iPos + 1) }
  iPos = sJustFn.lastIndexOf('/')
  if (iPos >= 0) { sJustFn = sJustFn.substr(iPos + 1) }
  sCurInsetPath = sCurPath + 'image/'
  //   sXmlFn = ReplaceGbk(sXmlFn)
  // alert(sXmlFn)
  // 解析XML，将结果保存到objDivPage中
  ParseXml(objDivRebuildPage, sXmlFn, nBzd)
}

// 根据xml文件显示竖版文字
function ParseXml (xml, nBzd, path, image) {
  objDivRebuildPage = document.getElementById('sDivId')
  page = path
  imageUrl = image
  $(objDivRebuildPage).empty() // 清空原来的内容
  if (IsPagetion) {
    if (arrayRowAll.length != 0) {
      var xmldata = xmlArrayList(arrayLists)
      arrayRows = loadarrayRows(arrayLists)
      loadXMLPages(xmldata, nBzd)
      return false
    }
  }
  //   $.ajax(
  //     {
  // 	    url: sXmlFn, // XML文件相对路径
  // 	    type: 'get', 			// 发送请求的方式
  // 	    dataType: 'text', // 指明文件类型为“xml”
  // 	    timeout: 5000, // 超时设置，单位为毫秒
  // 	    error: function (xml) { // 解析XML文件错误时的处理
  // 	        alert('加载XML文件（' + sXmlFn + '）出错！请检查该文件是否存在或者格式是否正确！')
  // 	    },
  // 	    success: function (xml) {
  // 	        // 判断
  	        if (xml == '') {
  	            ixmlcount++
  	            if (ixmlcount > 20) {
  	                layer.msg('加载xml超时！')
  	                return false
  	            }
  	            ParseXml(xml, nBzd, path, image)
  	            return false
  	        }

	        if (IsPagetion) {
	            var arrayli = jsonArrayList(xml)
	            var xmlstr = xmlArrayLists(arrayli)
	            loadarray(xmlstr)
	        }
	        //
	        loadXMLPages(xml, nBzd)
	    // }
  // })
}
function loadXMLPages (xml, nBzd) {
  var objDivRebuildPage = document.getElementById('sDivId')
  $(objDivRebuildPage).empty() // 清空原来的内容
  arrayRows = [] // 清空数组
  // 先查找顶部和底部图像
  sTopImage = $(xml).find('[type="topimage"]')
  sBottomImage = $(xml).find('[type="bottomimage"]')
  if (sTopImage.html() == undefined) { sTopImage = '' } else { sTopImage = sTopImage.html() }
  if (sBottomImage.html() == undefined) { sBottomImage = '' } else { sBottomImage = sBottomImage.html() }
  DivRowCount = 0
  // 读取页面或书本信息
  unit = Number(GetOnePara(xml, 'unit', '0'))
  version = parseInt(GetOnePara(xml, 'version', '0'))
  iImageWidth = parseInt(GetOnePara(xml, 'imgwidth', '0'))
  iImageHeight = parseInt(GetOnePara(xml, 'imgheight', '0'))
  iTxtLeft = parseInt(GetOnePara(xml, 'txtleft', '0'))
  iTxtTop = parseInt(GetOnePara(xml, 'txttop', '0'))
  iTxtRight = parseInt(GetOnePara(xml, 'txtright', '0'))
  iTxtBottom = parseInt(GetOnePara(xml, 'txtbottom', '0'))
  iThisLines = parseInt(GetOnePara(xml, 'lines', '0'))
  iThisHeightWords = parseInt(GetOnePara(xml, 'heightwords', '0'))
  iMinLines = parseInt(GetOnePara(xml, 'minlines', '0'))
  iMaxLines = parseInt(GetOnePara(xml, 'maxlines', '0'))
  iMaxHeightWords = parseInt(GetOnePara(xml, 'maxheightwords', '0'))
  DivRowCount = parseInt(GetOnePara(xml, 'lines', '0'))
  itopline = parseInt(GetOnePara(xml, 'topline', '0'))
  ibottomline = parseInt(GetOnePara(xml, 'bottomline', '0'))
  aspectratio = Number(GetOnePara(xml, 'aspectratio', '0'))
  pageheightwords = parseInt(GetOnePara(xml, 'pageheightwords', '0'))
  var pageType = GetOnePara(xml, 'type', '0')
  if (aspectratio > 0 && aspectratio <= 1) {
    aspectratio = 1.4
  }
  if (IsPagetion) {
    if (isExitPos) {
      version = VersionTe // 传递版本号
    }
  }
  // 显示比例
  Imgs_scale = 500 / iImageWidth
  isbottom = false
  var btlong = $(xml).find('row').length
  var outCount = 0, isImgBict = false
  // 读出每一行放到数组中
  $(xml).find('row').each(function (iRow, sRow) {
    var oCounts = $(xml).find('bl').length
    if (oCounts > outCount) { outCount = oCounts }
    var sOneLine = $(this).html()
    sOneLine = sOneLine.replace('\r', '')
    sOneLine = sOneLine.replace('\n', '')
    // if (g_isJt == 1) // 要转为简体
    // { sOneLine = t2s(sOneLine) }
    // 图像处理
    if (sOneLine.indexOf('[IMG') > 0 && btlong < 3) {
      var tcount = parseInt(GetOnePara(sOneLine, 'el', '0'))
      if (tcount > tbCount) {
        isImgBict = true
        tbCount = Math.ceil(tcount / 2)
      }
    } else if (sOneLine.indexOf('[IMG') > 0) {
      isImgBict = true
    }
    // else
    //	sOneLine=s2t(sOneLine)
    arrayRows[arrayRows.length] = sOneLine
    var outerHtml = this.outerHTML
    var outerBottom = parseInt(GetOnePara(outerHtml, 'bottom', '0'))
    var mobottom = (iImageHeight - outerBottom) * Imgs_scale
    if (mobottom < 150) { isbottom = true }
  })
  if (tbCount > 0 && outCount < 3 && version != 3) { DivRowCount = tbCount } else { tbCount = 0 }
  //
  var thing = findDimensions()
  if (!isregit && !IsPagetion) {
    // 顶部的距离
    var topScop = getElementToPageTop(objDivRebuildPage)
    // 自适应屏幕
    var iscale = iscale = (thing - (topScop + 20)) / iImageHeight
    var objHeight = topScop + $(objDivRebuildPage).height()
    if (thing > objHeight) {
      iscale = (thing - topScop + 20) / iImageHeight // 185顶部的距离
    }

    var mscale = ((820 - 20) / 2) / iImageWidth
    if (mscale < iscale) {
      Imgs_scale = iscale
      xImageWidth = iImageWidth * Imgs_scale
      xImageHeight = thing - topScop
    } else {
      Imgs_scale = mscale
      xImageWidth = ((820 - 20) / 2)
      xImageHeight = iImageHeight * Imgs_scale
    }
    // g_nSrcImgHeight = thing - topScop;
    ItextHeightpages = Imgs_scale * iImageHeight
    ItextHeightpage = (Imgs_scale * iTxtBottom - Imgs_scale * iTxtTop)
    ItextToppage = Imgs_scale * iTxtTop
    ItextLeftpage = Imgs_scale * iTxtLeft
  }
  // 处理
  if (!isregit && IsPagetion) {
    // DivRowCount = DivRowCounts;
    Imgs_scale = (thing - 35) / iImageHeight
    ItextHeightpages = Imgs_scale * iImageHeight
    ItextHeightpage = (Imgs_scale * iTxtBottom - Imgs_scale * iTxtTop)
    ItextToppage = Imgs_scale * iTxtTop
    ItextLeftpage = Imgs_scale * iTxtLeft
    if (iImageHeight == 0 || isBackfor) {
      itopline = -1
      ibottomline = -1
      Imgs_scale = 1
      iImageWidth = (thing) * 0.7
      iImageHeight = thing
      if (iImageWidth > 950 / 2) {
        iImageWidth = 950 / 2 - 40
      }
      ItextHeightpages = iImageHeight
      ItextHeightpage = 0
      ItextToppage = 100
      ItextLeftpage = 0
      if (DivRowCount < 1) { DivRowCount = 1 }
      iThisLines = 1; iTxtBottom = 0; iTxtTop = 100 // 没有的时候的默认值
    }
  }

  // 判断是否最小
  if (mimrowCounts > DivRowCount) {
    DivRowCount = mimrowCounts
  } //
  // 判断是否是封面
  isBackfor = false
  if (pageType == '封面') {
    var maxLengths = 0
    for (var i = 0; i < arrayRows.length; i++) {
      var arrayLines = arrayRows[i]
      var maxlen = parseInt(GetOnePara(arrayLines, 'el', '0'))
      if (maxlen / 2 > maxLengths) {
        maxLengths = parseInt(maxlen / 2)
      }
    }
    if (maxLengths > DivRowCount && iMaxLines > 0) {
      // DivRowCount = iMaxLines;
    }
    isBackfor = true
  }
  if (tbCount > 0) {

  }
  if (iMaxLines > 0 && iMaxLines > iThisLines) {
    DivRowCount = iMaxLines
  }
  if ((iImageHeight == 0 || isBackfor) && !IsPagetion) {
    itopline = -1
    ibottomline = -1
    Imgs_scale = 1
    iImageHeight = 3024
    iImageWidth = 1925
    iTxtTop = 200
    iTxtBottom = 2924
    // 顶部的距离
    var topScop = getElementToPageTop(objDivRebuildPage)
    // 自适应屏幕
    var iscale = iscale = (thing - (topScop + 20)) / iImageHeight
    var objHeight = topScop + $(objDivRebuildPage).height()
    if (thing > objHeight) {
      iscale = (thing - topScop + 20) / iImageHeight // 185顶部的距离
    }

    var mscale = ((820 - 20) / 2) / iImageWidth
    if (mscale < iscale) {
      Imgs_scale = iscale
      xImageWidth = iImageWidth * Imgs_scale
      xImageHeight = thing - topScop
    } else {
      Imgs_scale = mscale
      xImageWidth = ((820 - 20) / 2)
      xImageHeight = iImageHeight * Imgs_scale
    }
    // g_nSrcImgHeight = thing - topScop;
    ItextHeightpages = Imgs_scale * iImageHeight
    ItextHeightpage = (Imgs_scale * iTxtBottom - Imgs_scale * iTxtTop)
    ItextToppage = Imgs_scale * iTxtTop
    ItextLeftpage = Imgs_scale * iTxtLeft
  }
  // 生成显示内容
  ShowOnePage(objDivRebuildPage, nBzd)
}
// 报红字数
function fonColor (font) {
  // font = "人参|人參";
  var strfontlist = [] // 检索到的字
  var strfontlength = []
  var countup = 0 // 统计
  // 获取当前页面的所有字
  var fontstr = ''
  $.each($('.mypart'), function (i, n) {
    if ($(this).html().indexOf('img') == -1) {
      fontstr += $(this).html()
    } else {
      fontstr += '*'
    }
  })
  // 比较
  var fonts = font.split('|')
  var strLeng = fontstr // 临时变量
  for (var p = 0, i = 0; i < fonts.length; i++) {
    if (p == 1) {
      fontstr = strLeng
      countup = 0
    }
    if (fontstr.indexOf(fonts[i]) > -1) { // 进行匹配
      var fonlength = SplitStringToArray(fonts[i]).length
      //
      var indexfor = fontstr.indexOf(fonts[i])
      var strFons = fontstr.substring(0, indexfor)
      var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
      strfontlist.push(indexlngth + countup)
      strfontlength.push(fonlength)
      fontstr = fontstr.substring(indexfor + fonts[i].length, fontstr.length)
      //
      countup += indexlngth + fonts[i].length
      i--
      p = 0
    } else {
      p = 1
    }
  }
  TURNHEAD = ''; TURNTAIL = ''
  // 跨页检索
  for (var i = 0; i < fonts.length; i++) {
    var fonSplits = SplitStringToArray(fonts[i])
    var strSplits = SplitStringToArray(fontstr)
    var fristNo = true, lastNo = true
    for (var k = 0; k < fonts[i].length; k++) {
      // 首部检索
      var fontext = fonts[i].substring(k, fonts[i].length)
      if (fontstr.indexOf(fontext) > -1 && fristNo) {
        var indexfor = fontstr.indexOf(fontext)
        if (indexfor == 0) {
          TURNHEAD = fontext
          var fonlength = SplitStringToArray(fontext).length
          //
          var strFons = fontstr.substring(0, indexfor)
          var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
          strfontlist.push(indexlngth)
          strfontlength.push(fonlength)
          fristNo = false
        }
        //
      }
      // 尾部检索
      var fontext = fonts[i].substring(0, fonts[i].length - k)
      if (fontstr.indexOf(fontext) > -1 && lastNo) {
        var indexfor = fontstr.lastIndexOf(fontext)
        if (indexfor >= fontstr.length - fonts[i].length) {
          TURNTAIL = fontext
          var fonlength = SplitStringToArray(fontext).length
          //
          var strFons = fontstr.substring(0, indexfor)
          var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
          strfontlist.push(indexlngth)
          strfontlength.push(fonlength)
          lastNo = false
          //
        }
      }
    }
  }
  // 标红
  $.each($('.mypart'), function (i, n) {
    for (var j = 0; j < strfontlist.length; j++) {
      if (strfontlist[j] == i) {
        $(this).css('color', 'red')
        var fonthis = $(this)
        var b = i
        for (var k = 1; k < strfontlength[j]; k++) {
          $($('.mypart')[b + 1]).css('color', 'red')
          fonthis = fonthis.next()
          b++
        }
      }
    }
  })
}
// 封面加载
function backGroundColor () {
  var imgscr = '/images/bg.jpg'
  $('.div_pages').css({ 'background-image': 'url(' + imgscr + ')', 'background-size': '100% 100%' })
  $('.div_page').css('border', '0px')
  $('.div_row').css('border', '0px')
}

// 添加字体
function font_family () {

}
// 显示一页，生成内容保存到objDivPage中
function ShowOnePage (objDivRebuildPage, nBzd) {
  // 重重各行id
  iFontsid = 0 // 具体某一个字的id;
  iRowtsid = 0 // 大行小行的id
  iFontsids = 0 // 具体某一个字的id;
  iRowtsids = 0 // 大行小行的id
  //
  iZaoZiCount = 0
  //
  var iDivPageHeight = ItextHeightpage
  var i
  var iMaxWords = 0 // 最长行的字数
  var sOneLine
  var iTotalRowCount = DivRowCount // 需要显示的总行数
  var iWordRowCount = DivRowCount 	// 有文字的总行数
  var iStartShowRowNo = 0 // 从屏幕上的第几行开始显示
  var ToMaxSize = 0 // 一行里面最多可以容纳的字数;
  var iDrawLineCount = iTotalRowCount
  if (iMaxLines > 0) {
    iMinRows = iMaxLines
  }
  var ixWidths = xImageWidth
  iDivPageHeight = iMaxWords * (iFontSize + iFontSize * 0.13) + 52 // +iFontSize*0.5;	//需要显示的高度
  var iDivPageWidth = iDrawLineCount * iRowWidth
  // 加载行的宽度
  if (!isregit) {
    // 加载初始值
    iRowWidth = iOrgRowWidth
    iFontSize = iOrgFontSize
    fScale = 1
    ItextHeightpages = Imgs_scale * iImageHeight
    ItextHeightpage = (Imgs_scale * iTxtBottom - Imgs_scale * iTxtTop)
    ItextToppage = Imgs_scale * iTxtTop
    xImageWidth = iImageWidth * Imgs_scale
    xImageHeight = iImageHeight * Imgs_scale
    fScale = iRowWidth / iOrgRowWidth
    // 判断是否超出
    if ((ItextHeightpages + 40) > 514 - 20 && !IsPagetion) {
      ItextHeightpages = 514 + 8
      if (Imgs_scale != 1) {
        Imgs_scale = ItextHeightpages / iImageHeight
      }
      ItextHeightpage = ItextHeightpages
      ItextToppage = Imgs_scale * iTxtTop
      xImageWidth = iImageWidth * Imgs_scale
      xImageHeight = iImageHeight * Imgs_scale
    }
    g_nSrcImgHeight = ItextHeightpage + 40
    // 计算一页中行的最多字数
    txMaxSize = 0; MaxButtomHe = 0
    for (i = 0; i < arrayRows.length; i++) {
      sOneLine = arrayRows[i]
      var iLen = GetOneLineLen(sOneLine)
      if (iLen > iMaxWords) { iMaxWords = iLen }
      var xLens = GetOneLineLens(sOneLine)
      if (xLens > txMaxSize) { txMaxSize = xLens }
    }
    if (version == 2 || version == 3) {
      // 版本2计算方法
      txMaxSize = 0
      for (i = 0; i < arrayRows.length; i++) {
        sOneLine = arrayRows[i]
        var xLens = GetOneLinevs(sOneLine)
        if (xLens > txMaxSize) { txMaxSize = xLens }
      }
    }
    MaxButtomHe = txMaxSize
    var fonlenth = iMaxWords
    if (iThisHeightWords > 0) { iMaxWords = iThisHeightWords }
    if (iMaxHeightWords > 0) { iMaxWords = iMaxHeightWords }
    if (xImageWidth != 0) { ixWidths = xImageWidth }
    if (txMaxSize > 0) {
      iMaxWords = Math.ceil(txMaxSize)
    }
    if (txMaxSize.toString().indexOf('.5') > -1) {
      iMaxWords = txMaxSize
    }
    // 线框的顶部距离
    if (ItextToppage > DivTopLine) {
      ItextToppage = DivTopLine
    }
    var toplinss = Imgs_scale * itopline
    var bottomlss = Imgs_scale * ibottomline
    // 判断底部距离和顶部距离
    if (Imgs_scale * itopline > itopMinLine && Imgs_scale * ibottomline < ItextHeightpages) {
      ItextToppage = Imgs_scale * itopline
      ItextHeightpage = (Imgs_scale * ibottomline - Imgs_scale * itopline)
    }
    // 调整调整图像框线的底线
    if (ItextHeightpage + ItextToppage + DivButtomLine + 10 < ItextHeightpages) {
      ItextHeightpage = (ItextHeightpages - ItextToppage - DivButtomLine)
    } else if (ItextHeightpage + ItextToppage + 4 > ItextHeightpages) {
      ItextHeightpage = (ItextHeightpages - ItextToppage - DivButtomLine)
    }
    if (iMaxWords > 15) {
      isbottom = true
    } else if (iMaxWords > 8 && DivRowCount < 9) {
      isbottom = true
    } else if (iMaxWords < 10) {
      isbottom = false
    }
    // 自动适应字体大小isbottom
    if (IsPostMananger) {
      var fontsize = 32
      if (isbottom) {
        fontsize = (ItextHeightpage - 5) / iMaxWords / 1.2
        iOrgFontSize = fontsize
        iFontSize = fontsize
      }
    }
    // 调整图像框线的底线
    if (ItextHeightpage + ItextToppage > ItextHeightpages) {
      ItextToppage = (ItextHeightpages - ItextHeightpage) / 2
    }
    iDivPageHeight = iMaxWords * (iFontSize + iFontSize * 0.13) + 52
    // 判断内容是否超过底线
    if (iDivPageHeight > ItextHeightpage && !isbottom) {
      iOrgFontSize = (ItextHeightpage / iMaxWords) / 2.13
    }
    iRowWidth = iOrgFontSize //
    // 调整显示行的宽高
    var xRowWidthSize = (ixWidths - 30) / iDrawLineCount
    iDrawLineCount = Math.floor((ixWidths - 30) / xRowWidthSize)
    iRowWidth = xRowWidthSize
    if (xRowWidthSize > xMaxRowWidth) {
      iDrawLineCount = Math.ceil((ixWidths - 30) / xMaxRowWidth)
      xMinRowWidth = (ixWidths - 30) / iDrawLineCount
      iRowWidth = xMaxRowWidth
    }
    if (xRowWidthSize < xMinRowWidth) {
      iDrawLineCount = Math.ceil((ixWidths - 30) / xMinRowWidth)
      xMinRowWidth = (ixWidths - 30) / iDrawLineCount
      iRowWidth = xMinRowWidth
    }
    // 行数的判断
    if (DivRowCount > 0 && DivRowCount > iDrawLineCount) { iDrawLineCount = DivRowCount }
    xMinRowWidth = (ixWidths - 30) / iDrawLineCount
    iRowWidth = xMinRowWidth
    iOrgRowWidth = iRowWidth / 2
    iFontSize = iOrgFontSize
    DivRowCount = iDrawLineCount
    // 调整行数
    iDivPageWidth = iDrawLineCount * iRowWidth // 需要显示的宽度
    // 页面高度超过700，则根据最长的字符串长度进行计算
    if (iDivPageHeight > 700) {
      objDivRebuildPage.style.height = (iDivPageHeight + 60) + 'px'
    }

    // 字体大小超过行宽的时候
    if (iOrgFontSize > iRowWidth * 0.65) {
      iOrgFontSize = iRowWidth * 0.65
      iFontSize = iOrgFontSize
    }
    // 自动适应字体大小isbottom
    if (IsPostMananger) {
      if (!isbottom) {
        // 一行里面的所有字数
        var fontsize = iRowWidth * 0.65
        iOrgFontSize = fontsize
        iFontSize = fontsize
      }
    }
  }
  ChangeFonts()
  // 自动适应字体大小isbottom
  if (IsPostMananger) {
    if (aspectratio > 1 && isbottom) {
      aspectHeight = (ItextHeightpage - 5) / MaxButtomHe
    } else {
      aspectHeight = iRowWidth * 1.2
    }
  }
  // 新版数据的限定计算
  if (version == 3 && IsPostMananger) {
    if (aspectratio > 1 && isbottom) {
      aspectHeight = (ItextHeightpage - 5) / MaxButtomHe
    } else {
      aspectHeight = iFontSize * 1.2
    }
  }
  if (pageheightwords > 0) {
    aspectHeight = (ItextHeightpage - 5) / pageheightwords
  }
  iDivPageWidth = iDrawLineCount * iRowWidth // 需要显示的宽度
  /// /创建一个新的DIV，用于显示一页的数据   左边向左箭头
  var objLeftDiv = document.createElement('div')
  objLeftDiv.className = 'div_left'
  if (!IsPagetion) { objDivRebuildPage.appendChild(objLeftDiv) }

  if (g_nClicked == 3 || g_nClicked == -1) {
    // 图文对照
    var objPicPage = document.createElement('div')
    // if (!IsPagetion) {
    //   sJpgFn = pic_array[index2]
    // }
    // if (nBzd == 2) {
    //   sJpgFn = pic_array[index2].substr(0, pic_array[index2].length - 3) + 'png'
    // }
    //
    var objhtml = ''
    // sJpgFn = ReplaceGbk(sJpgFn)
    sJpgFn = imageUrl
    console.log('sJpgFn', sJpgFn)
    objhtml = '<img id="img_pic" src="' + sJpgFn + '" width="' + xImageWidth + 'px" height="' + ItextHeightpages + 'px"  style="box-shadow: 10px 10px 8px #888888;font-weight:bold;">'
    objPicPage.innerHTML = objhtml
    objDivRebuildPage.appendChild(objPicPage)
  }
  var lefDivPages = (ixWidths - iDivPageWidth) / 2
  ixWidths = xImageWidth
  // 图片大小的边距调整
  var numLeft = ((820 / 2) - ixWidths) / 2
  if (820 / 2 > ixWidths + 20) {
    objPicPage.style.left = 0 + 'px'
  } else {
    objPicPage.style.left = 0 + 'px'
  }
  // 调整缩放比例
  aspectHeightpe = 0
  toArrayitspaces = 0
  toArrayitspacNo = 0
  tocountses = 0; tocountsNo = 0
  var isTiFont = false
  //
  if (IsPostMananger) {
    if (isbottom) {
      //
      for (i = 0; i < arrayRows.length; i++) {
        sOneLine = arrayRows[i]
        ToItspaces(sOneLine)
        if (!isTiFont) {
          isTiFont = ToItspaces(sOneLine, 2)
        }
      }
      // 判断是否有大字
      if (isTiFont && version != 2 && version != 3) {
        toArrayitspaces = 0
        toArrayitspacNo = 0
        aspectHeightpe = aspectHeight
        for (i = 0; i < arrayRows.length; i++) {
          sOneLine = arrayRows[i]
          ToItspaces(sOneLine)
        }
        aspectHeight = aspectHeightpe
      }
    }
  }
  if (pageheightwords > 0) {
    aspectHeight = (ItextHeightpage - 5) / pageheightwords
  }
  // 赋值
  if (IsPagetion) {
    arrayLists.unit = (Math.floor(aspectHeight * 100) / 100) + ''
  }
  // 增加竖版的DIV外层
  var objDivPagesOut = document.createElement('div')
  objDivRebuildPage.appendChild(objDivPagesOut)
  objDivPagesOut.className = 'div_pages_out'
  var objDivPages = document.createElement('div')
  objDivPagesOut.appendChild(objDivPages)
  objDivPages.className = 'div_pages'
  // 右边向右箭头
  if (!IsPagetion) {
    // var objRightDiv = document.createElement('div')
    // objRightDiv.className = 'div_right'
    // if (!IsPagetion) { objDivRebuildPage.appendChild(objRightDiv) }
    // var objleftImg = document.createElement('img')
    // objleftImg.src = './images/leftarrowon.png'
    // objLeftDiv.appendChild(objleftImg)
    // var objrightImg = document.createElement('img')
    // objrightImg.src = './images/rightarrowon.png'
    // objRightDiv.appendChild(objrightImg)
  }
  // 增加竖版显示DIV
  var objDivPage = document.createElement('div')
  objDivPages.appendChild(objDivPage)
  objDivPage.className = 'div_page'
  // 页面的外边距、外层DIV
  objDivPagesOut.style.left = (lefDivPages - 10) + 'px'
  objDivPagesOut.style.width = (ixWidths + 40) + 'px'
  g_nImgHeight = ItextHeightpages + 40
  objDivPagesOut.style.height = (ItextHeightpages + 40) + 'px'
  // 页面的外边距、外层DIV
  objDivPages.style.width = ixWidths + 'px'
  objDivPages.style.height = ItextHeightpages + 'px'
  // 设置页的坐标
  objDivPage.style.left = (ixWidths - iDivPageWidth) / 2 - 10 + 'px' // 10边框距离
  objDivPage.style.width = iDivPageWidth + 6 + 'px'
  objDivPage.style.height = ItextHeightpage + 11 + 'px'
  if (IsPagetion) {
    objDivPage.style.height = ItextHeightpage + 5 + 'px'
  }
  if (g_nClicked == 3 || g_nClicked == -1) { // 图文对照
    objPicPage.className = 'div_pic'
    if (820 / 2 > ixWidths + 20) {
      objDivPagesOut.style.left = ((820 / 2) - 20) + 'px'
      if (IsPagetion) {
        objDivPages.style.left = ((820 / 2) - 20) + 'px'
      }
    } else {
      objDivPagesOut.style.left = ixWidths + 40 + 'px'
      if (IsPagetion) {
        objDivPages.style.left = ixWidths + 40 + 'px'
      }
    }
    iHeight = document.all.img_pic.height
    iHeight1 = iHeight
    if (iDivPageHeight > iHeight) { iHeight1 = iDivPageHeight + 60 }
    $('.sDivId').height(iHeight1)
    // alert(iHeight+"/"+iDivPageHeight)
    if (iHeight > iDivPageHeight) { // 图像高度大于竖版文字表格高度
      objDivPage.style.top = (iHeight - iDivPageHeight) / 2 + 'px'
    }
    objDivPage.style.top = ItextToppage + 'px'
  }
  //
  var arrayDivRows = new Array()
  var objDivRow_Line
  // 先画出框线
  var iRowLeft
  for (i = 0; i < iDrawLineCount; i++) {
    // 计算一行的坐标，生成div
    iRowLeft = iDivPageWidth - (i + 1) * iRowWidth
    objDivRow_Line = document.createElement('div')
    objDivPage.appendChild(objDivRow_Line)
    objDivRow_Line.className = 'div_row'
    // 设置行的坐标
    objDivRow_Line.style.left = (iRowLeft) + 'px'
    objDivRow_Line.style.height = (ItextHeightpage + 5) + 'px'
    objDivRow_Line.style.width = (iRowWidth) + 'px'
    if (i == iDrawLineCount - 1) { objDivRow_Line.style.borderLeft = 'solid 0px #FF7878' }
    arrayDivRows[i] = objDivRow_Line
  }
  // 左右箭头设置
  if (!IsPagetion) {
    // $('.div_xia').css('z-index', '1000')
    // iHeight = (parseInt(objDivPagesOut.style.height) - 120)
    // $('.div_left').mouseover(function () {
    //   objLeftDiv.style.opacity = 0.2
    //   objLeftDiv.style.height = iHeight + 'px'
    //   objLeftDiv.style.paddingTop = iHeight + 'px'
    // })
    // $('.div_left').hover(function () {
    //   objLeftDiv.style.opacity = 0.2
    //   objLeftDiv.style.height = iHeight + 'px'
    //   objLeftDiv.style.paddingTop = iHeight + 'px'
    // })
    // $('.div_left').mouseout(function () {
    //   objLeftDiv.style.opacity = 0.0
    // })
    // $('.div_right').mouseover(function () {
    //   objRightDiv.style.opacity = 0.2
    //   objRightDiv.style.height = iHeight + 'px'
    //   objRightDiv.style.paddingTop = iHeight + 'px'
    // })
    // $('.div_right').hover(function () {
    //   objRightDiv.style.opacity = 0.2
    //   objRightDiv.style.height = iHeight + 'px'
    //   objRightDiv.style.paddingTop = iHeight + 'px'
    // })
    // $('.div_right').mouseout(function () {
    //   objRightDiv.style.opacity = 0.0
    // })
    // $('.div_left').click(function () {
    //   ChangePrevPage()
    // })
    // $('.div_right').click(function () {
    //   ChangeNextPage()
    // })
  }
  iTotalRowCount = arrayRows.length // 需要显示的总行数
  iWordRowCount = arrayRows.length 	// 有文字的总行数
  // 处理外层DIV的高度高度
  var divpageOutHeight = parseInt($(objDivPage).outerHeight())
  var disobjDivHeights = (parseInt(objDivPages.style.height) - parseInt(objDivPage.style.top))
  if (disobjDivHeights <= divpageOutHeight) {
    objDivPages.style.height = parseInt(objDivPage.style.top) + parseInt(objDivPages.style.height) + 'px'
    objDivPagesOut.style.height = (parseInt(objDivPage.style.top) + parseInt(objDivPages.style.height) + 40) + 'px'
  }
  if (disobjDivHeights <= divpageOutHeight && version == 3) {
    // objDivPages.style.height = parseInt(objDivPage.style.top) + parseInt(objDivPages.style.height) + "px";
    // objDivPagesOut.style.height = (parseInt(objDivPage.style.top) + parseInt(objDivPages.style.height) + 40) + "px";
    objDivPage.style.top = parseInt(objDivPages.style.height) - parseInt(objDivPage.style.height) - 10 + 'px'
  }
  // 处理每一行
  var bFirst = true
  var arrRows = arrayRows
  if (IsPagetion) {
    if (arrayRowAll != null && arrayRowAll.length > 0) { arrRows = arrayRowAll }
  }
  for (i = 0; i < iTotalRowCount; i++) {
    objDivRow_Line = arrayDivRows[i]
    if (i >= iStartShowRowNo && i < iStartShowRowNo + iWordRowCount) {
      // 取出一行内容，进行判断
      sOneLine = arrRows[i - iStartShowRowNo]
      if (sOneLine == null) { break }

      if (version == 3) {
        ShowOneLineNex3(i, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iRowWidth - 2) // 点通定义的格式（增加了一些标记）iDivPageHeight
      } else if (version == 2) {
        ShowOneLineNex(i, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iRowWidth - 2) // 点通定义的格式（增加了一些标记）iDivPageHeight
      } else if (sOneLine.indexOf('<bl ') >= 0) {
        ShowOneLineDt(i, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iRowWidth - 2) // 点通定义的格式（增加了一些标记）iDivPageHeight
      } else { ShowOneLine(i, sOneLine, objDivRow_Line, iDivPageHeight) } 	// 原来客户提供的数据格式
    }
  }

  //   if (!IsPagetion) {
  //     // 增加缩放按键
  //     var objDivBack = document.createElement('div')
  //     var objDivZoomin = document.createElement('div')
  //     var objDivZoomout = document.createElement('div')
  //     var objDivPrevPage = document.createElement('div')
  //     var objDivNextPage = document.createElement('div')

  //     objDivPage.appendChild(objDivBack)
  //     objDivPage.appendChild(objDivPrevPage)
  //     objDivPage.appendChild(objDivNextPage)
  //     objDivPage.appendChild(objDivZoomin)
  //     objDivPage.appendChild(objDivZoomout)
  //     objDivBack.innerHTML = '<img src="../images/scanicon-back.png" onclick="ChangeWordSize(0)">'
  //     objDivPrevPage.innerHTML = '<img src="../images/scanicon-left.png" onclick="ChangePrevPage()">'
  //     objDivNextPage.innerHTML = '<img src="../images/scanicon-right.png" onclick="ChangeNextPage()">'
  //     objDivZoomin.innerHTML = '<img src="../images/scanicon-big.png" onclick="ChangeWordSize(10)">'
  //     objDivZoomout.innerHTML = '<img src="../images/scanicon-small.png" onclick="ChangeWordSize(-10)">'
  //     objDivBack.className = 'div_img'
  //     objDivPrevPage.className = 'div_img'
  //     objDivNextPage.className = 'div_img'
  //     objDivZoomin.className = 'div_img'
  //     objDivZoomout.className = 'div_img'
  //     objDivBack.style.top = (iDivPageHeight + 25) + 'px'
  //     objDivPrevPage.style.top = (iDivPageHeight + 25) + 'px'
  //     objDivNextPage.style.top = (iDivPageHeight + 25) + 'px'
  //     objDivZoomin.style.top = (iDivPageHeight + 25) + 'px'
  //     objDivZoomout.style.top = (iDivPageHeight + 25) + 'px'
  //     objDivBack.style.left = (iDivPageWidth - 240) + 'px'
  //     objDivPrevPage.style.left = (iDivPageWidth - 180) + 'px'
  //     objDivNextPage.style.left = (iDivPageWidth - 130) + 'px'
  //     objDivZoomin.style.left = (iDivPageWidth - 80) + 'px'
  //     objDivZoomout.style.left = (iDivPageWidth - 40) + 'px'
  //     // 隐藏
  //     objDivBack.style.display = 'none'
  //     objDivPrevPage.style.display = 'none'
  //     objDivNextPage.style.display = 'none'
  //     objDivZoomin.style.display = 'none'
  //     objDivZoomout.style.display = 'none'
  //   }
  // 判断是否是封面
  if (isBackfor) {
    backGroundColor()
  }
  // 改变字体
  font_family()
  // 加载判断字体是否标红
  if (cTurnRedFt.length > 0) { // if (cTurnRedFt.length > 1) {
    fonColor(cTurnRedFt)
  }
  // 异体字
  readyFont()
  //
  //   if (!IsPagetion) { mountFont() }
  //
  NotWords()
}
function NotWords () {
  // 处理双行小字不对齐的问题
  if (($('.note_words').length != 0 || $('.note_bottom_words').length != 0 || $('.note_top_words').length != 0) && version == 3) {
    var LinesHe = ''
    $('.note_words').each(function (index) {
      var margTop = $(this).css('margin-top')
      $(this).css('margin-top', '0px')
      var notdiv = $(this).find('div')
      var nothegiht = notdiv.last().height()
      notdiv.last().height(nothegiht - 2)
      notdiv.css('margin-top', margTop)
      LinesHe = this.style.lineHeight
      notdiv.css('line-height', LinesHe == '' ? 'normal' : LinesHe)
    })
    $('.note_top_words').each(function (index) {
      var margTop = $(this).css('margin-top')
      $(this).css('margin-top', '-2px')
      var notdiv = $(this).find('div')
      var nothegiht = notdiv.last().height()
      notdiv.last().height(nothegiht - 2)
      notdiv.css('margin-top', margTop)
      LinesHe = this.style.lineHeight
      notdiv.css('line-height', LinesHe == '' ? 'normal' : LinesHe)
    })
    $('.note_bottom_words').each(function (index) {
      var margTop = $(this).css('margin-top')
      $(this).css('margin-top', '0px')
      var notdiv = $(this).find('div')
      var nothegiht = notdiv.last().height()
      notdiv.last().height(nothegiht - 2)
      notdiv.css('margin-top', margTop)
      LinesHe = this.style.lineHeight
      notdiv.css('line-height', LinesHe == '' ? 'normal' : LinesHe)
    })
  }
  var note_bottom_bt = $('.note_bottom_words')
  var note_top_bt = $('.note_top_words')
  if (note_bottom_bt.length > 0) {
    note_bottom_bt.css('top', '-11px')
  }
}
// version3的新版数据（增加了一些标记）
// 用block标记将每一行（字块）标记出来
function ShowOneLineNex3 (iLineNo, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iDivPageWidth) {
  var arrayOneLine = new Array(); nextreadNo = 0
  arrayOneLine = sOneLine.split('</bl>')
  var iStartLineNo, iEndLineNo, iTopSpace, iFormatType, iFieldNo, iFontSizeNo, iBlockHeight
  var iLeft, iTop, iWidth, iHeight
  var objParent, objLine, objLine2, objDivBlock
  var iThisLineNo, iThisLineNo2, iThisLineWidth
  var iWordType = 1
  var iThisFontSize = iFontSize
  var sClassName = ''
  var iTopcount = 0, leftcount = -1, itops = -1, iBottomSpace = -1 // 累加顶部的空白字符数的高度
  leftToLine = -1; isFieleTe = false, ipRowFonts = -1 // 设置初始值
  var iileft = 0, IpTop = 0 // 小小字的处理、超行重叠
  IpRowpos = 0 // 超行重叠处理;
  var nextiFieldNo = -1, nextTop = -1 // 上一行的开始行号，上上一行的高度 //处理大字超出
  var nextTopmin = -1, nextTopmins = -1, istopmin = false, nextopst = -1 /// /上一行的开始行号，上上一行的高度 //处理小行小字超出
  var nextThis = -1 // 小小字的显示记录方式（处理显示）
  var iTopSpaces = '', iBottomSpaces = ''
  var lastitspacespe = -1 // 记录上一行的缩放比例
  var lastbuttompa = -1, lasttoppa = -1 // 记录上一行的高度bs和ts
  var islasttoppace = false
  var rate = 0 // version 3 中的缩放比例
  // 按照文字块进行显示
  for (var i = 0; i < arrayOneLine.length - 1; i++) {
    var sOneBlock = arrayOneLine[i], ispost = false
    rate = Number(GetOnePara(sOneBlock, 'rate', '0')) // version2中的缩放比例
    iStartLineNo = parseInt(GetOnePara(sOneBlock, 'sl', '0')) // 开始行号
    iEndLineNo = parseInt(GetOnePara(sOneBlock, 'el', '0')) // 结束行号
    iTopSpace = Number(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
    iBottomSpace = Number(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    iTopSpaces = GetOnePara(sOneBlock, 'ts', '0') 	// 与顶部的空白字符数
    iBottomSpaces = GetOnePara(sOneBlock, 'bs', '0') // 顶部到底部的空格字数
    iFormatType = parseInt(GetOnePara(sOneBlock, 'tp', '0')) // 排版格式（与画框相同）
    iFieldNo = parseInt(GetOnePara(sOneBlock, 'fn', '0')) 	// 字段编号（与画框相同）
    iFontSizeNo = parseFloat(GetOnePara(sOneBlock, 'fs', '0')) // 字号大小，小字为1，普通正文文字为2，其它字号为小字的倍数
    iBlockHeight = parseInt(GetOnePara(sOneBlock, 'bh', '0')) // 高度，以小字数为单位
    iRowtsids = GetOnePara(sOneBlock, 'rid', '0') // 具体行的id
    // 判断
    if (aspectratio <= 1) {
      iTopSpace = parseInt(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
      iBottomSpace = parseInt(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    }
    sOneBlock = DeleteSubString(sOneBlock, '<bl ', '>')
    objDivBlock = document.createElement('div')
    iThisFontSize = iFontSize * iFontSizeNo / 2
    iThisLineNo = parseInt(iStartLineNo / 2)
    iThisLineNo2 = parseInt(iEndLineNo / 2)
    objLine = arrayDivRows[iThisLineNo]
    objLine2 = arrayDivRows[iThisLineNo2]
    objParent = arrayDivRows[iThisLineNo]
    iThisLineWidth = parseInt(iDivPageWidth)
    if (iFieldNo == 3) { iThisFontSize = (iThisFontSize * 0.6) * iSMScale } // iThisFontSize字
    else if (iFieldNo == 8) { iThisFontSize = (iThisFontSize * 0.6) * iTBScale } else if (iFieldNo == 9) { iThisFontSize = (iThisFontSize * 0.6) * iBTScale } else if (iFieldNo == 27) { iThisFontSize = (iThisFontSize * 0.6) * iTSScale }
    // 小字处理
    if (iFontSizeNo == 1) { iThisFontSize = iFontSize * 0.65 }
    // 小小字的处理
    if (iFieldNo == 0) { iThisFontSize = (iFontSize * 0.7) * 0.6 }
    var XeHeight = -1
    iHeight = -1
    // 顶部距离处理
    iTop = iTopSpace * iFontSize * 1.2
    iTop += 5
    // 正文
    if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0) {
      // 没有跨行，大字正文
      iLeft = (iThisLineWidth - iThisFontSize) / 2
      iWidth = iThisFontSize
      iWordType = 1
      objDivBlock.className = 'div_block_bigzw'
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 0) {
      // 没有跨行，小字正文，右边行
      iLeft = iThisLineWidth / 2 + 2
      iWidth = iThisFontSize
      iWordType = 2
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
      // 没有跨行，小字正文，左边行
      iLeft = iThisLineWidth / 2 - iThisFontSize - 2
      iWidth = iThisFontSize
      iWordType = 3
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
      if ((iEndLineNo / 2 == DivRowCount - 1 || iStartLineNo / 2 == DivRowCount - 1) && iLeft < 4) {
        iLeft = 5
      }
    } else {
      objParent = objDivPage
      // 有跨行，或其它字段
      if (iEndLineNo % 2 == 0) {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + parseInt(objLine2.style.width) / 2 + 1 }
      } else {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + 1 }
      }
      if (iStartLineNo % 2 == 0) {
        if (objLine != null) { iWidth = parseInt(objLine.style.width) * 0.65 }
      } else if (objLine != null) {
        iWidth = parseInt(objLine.style.left) - iLeft + parseInt(objLine.style.width) / 2 - 2
        iWidth /= 2
      }
      if (iFieldNo == 3) { objDivBlock.className = 'div_block_bookname' } else if (iFieldNo == 8) { objDivBlock.className = 'div_block_imgbt' } else if (iFieldNo == 9) { objDivBlock.className = 'div_block_title' } else if (iFieldNo == 27) { objDivBlock.className = 'div_block_imgsm' } else if (iFieldNo == 0) { objDivBlock.className = 'div_block_smallzw_sm' } else if (iFieldNo == 10) { objDivBlock.className = 'div_block_smallzw_sh' } else if (iFieldNo == 19) {
        objDivBlock.className = 'div_insert'
        iHeight = parseInt(iBlockHeight * iFontSize * 1.2 + 0.4)
      }
      if (iFieldNo != 27 && iFieldNo != 19 && (iFormatType == 1 || iFormatType == 2) && iFieldNo != 3) {
        // 竖版，则将宽度限定为字宽
        iLeft = iLeft + (iWidth - iThisFontSize) / 2
        iWidth = iThisFontSize
      }
      //
      if (iFieldNo == 3 || iFieldNo == 9 || iFieldNo == 8 || iFieldNo == 27 || (iFieldNo == 19 && tbCount == 0)) {
        iWidth = ((iEndLineNo + 1) - (iStartLineNo)) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2)
        //
        var idvwidhtst = iImageWidth * Imgs_scale
        XeHeight = iThisFontSize * 1.2
      }
      // 插图处理
      if (iFieldNo == 19) {
        iWidth = (iEndLineNo - iStartLineNo) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - iEndLineNo / 2)
        if (iLeft < 0) {
          iLeft = 0
        }
        iTop = iTopSpace * aspectHeight + 5
        XeHeight = iBlockHeight * aspectHeight + 5
      }
      iWordType = 4
    }
    // 小字三行的处理
    if (iFieldNo == 10) {
      iThisFontSize = iFontSize * 0.5
      iWidth = iThisFontSize
      XeHeight = iWidth * 1.4
      if (iStartLineNo % 2 == 0) {
        if (iEndLineNo == iStartLineNo) { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 * 2 + parseInt(objLine2.style.left) } else { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 + parseInt(objLine2.style.left) }
      } else {
        iLeft = (iRowWidth / 3 - iWidth) / 2 + parseInt(objLine2.style.left)
      }
    }
    // 小小字的处理
    if (iFieldNo == 0) {
      var tiTop = iTop
      if (iileft == 1 && nextThis != iEndLineNo && nextThis != -1) {
        iileft = 0
      }
      if (iileft == 0) { // 右
        iWidth = (iRowWidth - 2) / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2) + iWidth + 1
        XeHeight = iThisFontSize * 1.2
        iileft++
        // 第一行的时候
        if (nextTop < 0) {
          nextTop = iTop
        } else if (iTopSpace != 0 && i != 0) {
          iTop = IpRowpos
          ipRowFonts = IpRowpos
        }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0) {
          iTop = tiTop
          nextTop = tiTop
        }
        nextThis = iEndLineNo
      } else {
        iWidth = (iRowWidth - 2) / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2) + 1
        //
        XeHeight = iThisFontSize * 1.2
        iileft = 0
        if (ipRowFonts != -1) { iTop = ipRowFonts }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0 && iStartLineNo % 2 == 1) {
          iTop = tiTop
          nextTop = tiTop
        }
        nextThis = -1
      }
    }
    if (XeHeight < 0) { XeHeight = 1 * iFontSize * 1.2 }
    if (iFontSizeNo != 2) {
      iTop += nextreadNo
    }
    var chilenst = document.getElementById('r' + iRowtsid)
    var ischileFiles = true
    if (itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.1) {
      ischileFiles = false
    }
    // 小小行跨行处理
    if (iFieldNo != 0) {
      iileft = 0
    }
    IpTop = iTop
    if (iFieldNo != 0) {
      nextTop = IpRowpos
    }
    // 小行显示的数据超出下面大行处理
    if (iFontSizeNo == 1) { nextTopmins = nextTopmin }
    var itxtCount = iBottomSpace - iTopSpace
    var isboTop = false
    // 处理大字显示是否变瘦问题
    if ((iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
      if (iBottomSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      } else if (iTopSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      }
    }
    var newheightAsp = 0
    // 改变字体的长度（字变瘦）
    if (iFieldNo != 19 && itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.0 && iFieldNo != 3) {
      //
      var iTopbks = iTop
      var sOnebk = sOneBlock
      var aspectionblck = 0 // 记录使用的缩放比例
      var aspLinetCount = 0 // 记录括号所占的像素点
      if (IsPagetion) {
        sOnebk = DeleteSubString(sOneBlock, '<txt ', '>')
        while (sOnebk.indexOf('</txt>') > -1) {
          sOnebk = sOnebk.replace('</txt>', '')
        }
      }
      var sOnebks = sOnebk
      var cpsdk = false // 有括号
      if (sOnebks.indexOf('（') > -1 || sOnebks.indexOf('）') > -1) {
        cpsdk = true
      }
      var countbk = 0 // 括号的占比
      while (sOnebks.indexOf('（') > -1) {
        sOnebks = sOnebks.replace('（', '')
        aspLinetCount += 2
        countbk += 2
      }
      while (sOnebks.indexOf('）') > -1) {
        sOnebks = sOnebks.replace('）', '')
        aspLinetCount += 2
        countbk += 2
      }
      if (countbk < 3) {
        countbk = 0
      }
      var itxtCountlength = SplitStringToArray(sOnebks).length
      if (sOnebks == '') {
        itxtCountlength = 0
      }
      var itextSpaces = iFontSize * 1.2
      var itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
      if (itextSpaces != XeHeight || (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        } else {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        }
      } else {
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
        }
      }
      objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
      aspectionblck = itspaces
      objDivBlock.style.transformOrigin = 'top'
      if ((iBottomSpaces.toString().indexOf('.') > -1)) {
        iTop = iTopSpace * aspectHeight + 5
      }
      iTopbks = iTop
      var isFonLineFss = false
      // 处理version3中的统一字体大小（双行小字统一比例）
      if (version == 3 && i > 0) {
        var sOneBlcks = arrayOneLine[i - 1]
        var lastiTopSpace = Number(GetOnePara(sOneBlcks, 'ts', '0'))
        var lastiBottomSpace = Number(GetOnePara(sOneBlcks, 'bs', '0'))
        if (!(lastiBottomSpace == iBottomSpace && lastiTopSpace == iTopSpace) && iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
          objDivBlock.style.transform = 'scaleY(' + lastitspacespe + ')'
          itspaces = lastitspacespe
          aspectionblck = lastitspacespe
        }
      }
      lastitspacespe = itspaces
      if (IsPagetion && isPagepaces) {
        itspaces = Math.floor(itspaces * 100) / 100
        objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
        aspectionblck = itspaces
        iTop = iTopSpace * aspectHeight + 5
        // 赋值
        onHeightOred(iRowtsids, itspaces)
      }
      // 记录上一行的高度和ts
      lastbuttompa = aspectionblck * (XeHeight * itxtCountlength)
      if (ispost) {
        lastbuttompa = aspectionblck * (XeHeight * itxtCountlength * 0.65)
      }
      lastitspacespe = aspectionblck
      lasttoppa = iTop
      if (version == 3) {
        objDivBlock.style.transform = 'scaleY(1)'
        objDivBlock.style.transformOrigin = 'top'
        newheightAsp = aspectHeight * itxtCount
      }
    } else {
      iTop = iTopSpace * aspectHeight + 5
    }
    //
    if (iTop == 0) {
      iTop = 5
    }
    if (iFieldNo != 19) {
      XeHeight = aspectHeight
    }
    //
    ShowOneString(sOneBlock, iThisFontSize, iWordType, iFormatType, objDivBlock, iLeft, iTop, iWidth, iHeight, sClassName, ispost, XeHeight, iFieldNo)
    if (objParent != null) { objParent.appendChild(objDivBlock) }
    if (iFieldNo != 0) { nextiFieldNo = iStartLineNo }
    if (iFontSizeNo == 1)// 小行显示的数据超出下面大行处理
    {
      nextopst = iTop
      nextTopmin = IpRowpos
    } else { nextTopmin = -1 }
    ShowMonAttr(i, newheightAsp, objDivBlock, itxtCountlength)
  }
}
var lastpapings = 0 // 上一小行的间距
// 分析页面字体缩放比例的大小
// 压字情况处理（version3）
function ShowMonAttr (i, newheightAsp, objDivBlock, itxtCountlength) {
  // 调整间距
  if (version == 3 && newheightAsp > 0) {
    // 原始高度
    var objDivBlocks = $(objDivBlock)
    var oldheight = objDivBlocks.outerHeight()
    var asDivHieghts = objDivBlocks.children().outerHeight()
    if (objDivBlocks.children()[0].className != 'mypart') {
      asDivHieghts = objDivBlocks.children().children().outerHeight()
    }
    // 变化之后高度
    var newheight = newheightAsp
    isMinCaleBs = (isMinCaleBs == null ? 1 : isMinCaleBs)
    if (lastpapings > 0 && objDivBlocks.attr('class') == 'div_block_smallzw' && Number(objDivBlocks.css('left').replace('px', '')) < objDivBlocks.width()) {
      objDivBlocks.children().css('margin-top', lastpapings + 'px')
      var objDivHeights = objDivBlocks.children().height()
      if ($(objDivBlocks.children()[0]).attr('class') != 'mypart') {
        objDivHeights = objDivBlocks.children().children().height()
      }
      objDivBlocks.children().css('line-height', (objDivHeights - lastpapings) + 'px')
    }
    // div_block_smallzw
    else if (newheight - oldheight > asDivHieghts * isMinCaleBs && itxtCountlength > 1) {
      var posed = objDivBlocks.children().length * objDivBlocks.children().eq(0).height()
      // 增加间距
      var papings = (newheight - oldheight) / itxtCountlength
      objDivBlocks.children().css('margin-top', papings + 'px')
      var objDivHeights = objDivBlocks.children().height()
      if ($(objDivBlocks.children()[0]).attr('class') != 'mypart') {
        objDivHeights = objDivBlocks.children().children().height()
      }
      objDivBlocks.children().css('line-height', (objDivHeights - papings) + 'px')
      lastpapings = papings
      if (i > 0 && objDivBlocks.prev().length != 0 && objDivBlocks.prev().length != 0) {
        if (Number(objDivBlocks.prev().css('top').replace('px', '')) == Number(objDivBlocks.css('top').replace('px', '')) && objDivBlocks.prev().attr('class') == 'div_block_smallzw') {
          objDivBlocks.prev().children().css('margin-top', papings + 'px')
          var objDivHeights = objDivBlocks.prev().children().height()
          if ($(objDivBlocks.prev().children()[0]).attr('class') != 'mypart') {
            objDivHeights = objDivBlocks.prev().children().children().height()
          }
          objDivBlocks.prev().children().css('line-height', (objDivHeights - papings) + 'px')
        }
      }
    } else {
      lastpapings = 0
    }
  }
  // 处理压字的情况
  if (i > 0) {
    // 判断不是同一种类型
    var className1 = $(objDivBlock).attr('class')
    var className2 = $(objDivBlock).prev().attr('class')
    if (className1 != className2) {
      // 右小行
      var poseds = 0 // 间距
      var heights = $($(objDivBlock).prev())
      var heightspe = $($(objDivBlock).prev().prev())
      if (heights.length == 0) { return false }
      var lengthX = heights.children().length
      var tranforX = heights.css('transform').replace(/[^0.00-9.99\-,]/g, '').split(',')[3]
      var hsHeightX = heights.outerHeight() * Number(tranforX)
      var hsHeight = heights.outerHeight()

      //
      var objtops = Number($(objDivBlock).css('top').replace('px', ''))
      var hsttops = Number(heights.css('top').replace('px', ''))
      if (objtops < hsHeightX + hsttops && (hsttops < objtops)) {
        // 判断间距是否充足
        poseds = 0
        heights.children().each(function () {
          poseds += Number($(this).css('margin-top').replace('px', ''))
        })
        poseds = (objtops - hsttops) - (hsHeightX - poseds)
        if (poseds > 0 && poseds != null) {
          var podes = poseds / heights.children().length
          heights.children().css('margin-top', podes + 'px')
          if (heightspe.length == 0) { return false }
          if ($(heightspe).attr('class') == 'div_block_smallzw' && heights.css('top') == heightspe.css('top')) {
            podes = poseds / $(objDivBlock).prev().prev().children().length
            heightspe.children().css('margin-top', podes + 'px')
          }
        } else {
          itspaces = (objtops - hsttops) / hsHeight
          $(objDivBlock).prev()[0].style.transform = 'scaleY(' + itspaces + ')'
          if (heightspe.length == 0) { return false }
          if ($(heightspe).attr('class') == 'div_block_smallzw' && heights.css('top') == heightspe.css('top') && $(heights).attr('class') == 'div_block_smallzw') {
            if (poseds < 0 && $(heights).attr('class') == 'div_block_smallzw') {
              heightspe.children().css('margin-top', '0px')
              hsHeight = heights.outerHeight()
            }
            $(objDivBlock).prev().prev()[0].style.transform = 'scaleY(' + itspaces + ')'
          }
        }
      }
      if (heightspe.length == 0) { return false }
      // 左小行
      if ($(heightspe).attr('class') == 'div_block_smallzw' && heights.css('top') == heightspe.css('top')) {
        var lengthX = heightspe.children().length
        var tranforpeX = heightspe.css('transform').replace(/[^0.00-9.99\-,]/g, '').split(',')[3]
        var hstheightsX = heightspe.outerHeight() * Number(tranforpeX)
        var hstheights = heightspe.outerHeight()
        //
        var hstpeTops = Number(heightspe.css('top').replace('px', ''))
        if (objtops < hstheightsX + hstpeTops && (hstpeTops < objtops)) {
          poseds = 0
          // 判断间距是否充足
          heightspe.children().each(function () {
            poseds += Number($(this).css('margin-top').replace('px', ''))
          })
          poseds = (objtops - hstpeTops) - (hstheightsX - poseds)
          if (poseds > 0 && poseds != null) {
            if ($(heights).attr('class') == 'div_block_smallzw' && heights.css('top') == heightspe.css('top')) {
              var rposd = poseds / heightspe.children().length
              heightspe.children().css('margin-top', rposd + 'px')
              heights.children().css('margin-top', rposd + 'px')
            }
          } else {
            itspaces = (objtops - hstpeTops) / hstheights
            $(objDivBlock).prev().prev()[0].style.transform = 'scaleY(' + itspaces + ')'
            if ($(heights).attr('class') == 'div_block_smallzw' && heights.css('top') == heightspe.css('top')) {
              if (poseds < 0) {
                heightspe.children().css('margin-top', '0px')
                hstheights = heightspe.outerHeight()
              }
              $(objDivBlock).prev()[0].style.transform = 'scaleY(' + itspaces + ')'
            }
          }
        }
      }
    }
  }
  // 判断是否超出底部
  var htmlPageHeight = $('.div_row').outerHeight()
  var objDivHeight = $(objDivBlock).outerHeight()
  var objDivTop = Number($(objDivBlock).css('top').replace('px', ''))
  if (htmlPageHeight < objDivHeight + objDivTop) {
    itspaces = (htmlPageHeight - 5) / (objDivHeight + objDivTop)
    objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
  }
}

// version2的新版数据（增加了一些标记）
// 用block标记将每一行（字块）标记出来
function ShowOneLineNex (iLineNo, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iDivPageWidth) {
  var arrayOneLine = new Array(); nextreadNo = 0
  arrayOneLine = sOneLine.split('</bl>')
  var iStartLineNo, iEndLineNo, iTopSpace, iFormatType, iFieldNo, iFontSizeNo, iBlockHeight
  var iLeft, iTop, iWidth, iHeight
  var objParent, objLine, objLine2, objDivBlock
  var iThisLineNo, iThisLineNo2, iThisLineWidth
  var iWordType = 1
  var iThisFontSize = iFontSize
  var sClassName = ''
  var iTopcount = 0, leftcount = -1, itops = -1, iBottomSpace = -1 // 累加顶部的空白字符数的高度
  leftToLine = -1; isFieleTe = false, ipRowFonts = -1
  var iileft = 0, IpTop = 0 // 小小字的处理、超行重叠
  IpRowpos = 0 // 超行重叠处理;
  var nextiFieldNo = -1, nextTop = -1 // 上一行的开始行号，上上一行的高度 //处理大字超出
  var nextTopmin = -1, nextTopmins = -1, istopmin = false, nextopst = -1 /// /上一行的开始行号，上上一行的高度 //处理小行小字超出
  var nextThis = -1 // 小小字的显示记录方式（处理显示）
  var iTopSpaces = '', iBottomSpaces = ''
  var lastitspacespe = -1 // 记录上一行的缩放比例
  var lastbuttompa = -1, lasttoppa = -1 // 记录上一行的高度bs和ts
  var islasttoppace = false
  var rate = 0 // version2中的缩放比例
  // 按照文字块进行显示
  for (var i = 0; i < arrayOneLine.length - 1; i++) {
    var sOneBlock = arrayOneLine[i], ispost = false

    rate = Number(GetOnePara(sOneBlock, 'rate', '0')) // version2中的缩放比例
    iStartLineNo = parseInt(GetOnePara(sOneBlock, 'sl', '0')) // 开始行号
    iEndLineNo = parseInt(GetOnePara(sOneBlock, 'el', '0')) // 结束行号
    iTopSpace = Number(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
    iBottomSpace = Number(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    iTopSpaces = GetOnePara(sOneBlock, 'ts', '0') 	// 与顶部的空白字符数
    iBottomSpaces = GetOnePara(sOneBlock, 'bs', '0') // 顶部到底部的空格字数
    iFormatType = parseInt(GetOnePara(sOneBlock, 'tp', '0')) // 排版格式（与画框相同）
    iFieldNo = parseInt(GetOnePara(sOneBlock, 'fn', '0')) 	// 字段编号（与画框相同）
    iFontSizeNo = parseFloat(GetOnePara(sOneBlock, 'fs', '0')) // 字号大小，小字为1，普通正文文字为2，其它字号为小字的倍数
    iBlockHeight = parseInt(GetOnePara(sOneBlock, 'bh', '0')) // 高度，以小字数为单位
    iRowtsids = GetOnePara(sOneBlock, 'rid', '0') // 具体行的id
    // 判断
    if (aspectratio <= 1) {
      iTopSpace = parseInt(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
      iBottomSpace = parseInt(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    }
    sOneBlock = DeleteSubString(sOneBlock, '<bl ', '>')
    objDivBlock = document.createElement('div')

    //
    iThisFontSize = iFontSize * iFontSizeNo / 2
    iThisLineNo = parseInt(iStartLineNo / 2)
    iThisLineNo2 = parseInt(iEndLineNo / 2)
    objLine = arrayDivRows[iThisLineNo]
    objLine2 = arrayDivRows[iThisLineNo2]
    objParent = arrayDivRows[iThisLineNo]
    iThisLineWidth = parseInt(iDivPageWidth)
    if (iFieldNo == 3) { iThisFontSize = (iThisFontSize * 0.6) * iSMScale } // iThisFontSize字
    else if (iFieldNo == 8) { iThisFontSize = (iThisFontSize * 0.6) * iTBScale } else if (iFieldNo == 9) { iThisFontSize = (iThisFontSize * 0.6) * iBTScale } else if (iFieldNo == 27) { iThisFontSize = (iThisFontSize * 0.6) * iTSScale }
    // 小字处理
    if (iFontSizeNo == 1) { iThisFontSize = iFontSize * 0.65 }
    // 小小字的处理
    if (iFieldNo == 0) { iThisFontSize = (iFontSize * 0.7) * 0.6 }
    var XeHeight = -1
    iHeight = -1
    // 顶部距离处理
    iTop = iTopSpace * iFontSize * 1.2
    iTop += 5
    // 正文
    if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0) {
      // 没有跨行，大字正文
      iLeft = (iThisLineWidth - iThisFontSize) / 2
      iWidth = iThisFontSize
      iWordType = 1
      objDivBlock.className = 'div_block_bigzw'
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 0) {
      // 没有跨行，小字正文，右边行
      iLeft = iThisLineWidth / 2 + 2
      iWidth = iThisFontSize
      iWordType = 2
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
      // 没有跨行，小字正文，左边行
      iLeft = iThisLineWidth / 2 - iThisFontSize - 2
      iWidth = iThisFontSize
      iWordType = 3
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
      if ((iEndLineNo / 2 == DivRowCount - 1 || iStartLineNo / 2 == DivRowCount - 1) && iLeft < 4) {
        iLeft = 5
      }
    } else {
      objParent = objDivPage
      // 有跨行，或其它字段
      if (iEndLineNo % 2 == 0) {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + parseInt(objLine2.style.width) / 2 + 1 }
      } else {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + 1 }
      }
      if (iStartLineNo % 2 == 0) {
        if (objLine != null) { iWidth = parseInt(objLine.style.width) * 0.65 }
      } else if (objLine != null) {
        iWidth = parseInt(objLine.style.left) - iLeft + parseInt(objLine.style.width) / 2 - 2
        iWidth /= 2
      }

      if (iFieldNo == 3) { objDivBlock.className = 'div_block_bookname' } else if (iFieldNo == 8) { objDivBlock.className = 'div_block_imgbt' } else if (iFieldNo == 9) { objDivBlock.className = 'div_block_title' } else if (iFieldNo == 27) { objDivBlock.className = 'div_block_imgsm' } else if (iFieldNo == 0) { objDivBlock.className = 'div_block_smallzw_sm' } else if (iFieldNo == 10) { objDivBlock.className = 'div_block_smallzw_sh' } else if (iFieldNo == 19) {
        objDivBlock.className = 'div_insert'
        iHeight = parseInt(iBlockHeight * iFontSize * 1.2 + 0.4)
      }
      if (iFieldNo != 27 && iFieldNo != 19 && (iFormatType == 1 || iFormatType == 2) && iFieldNo != 3) {
        // 竖版，则将宽度限定为字宽
        iLeft = iLeft + (iWidth - iThisFontSize) / 2
        iWidth = iThisFontSize
      }
      // 插图处理
      if (iFieldNo == 19) {
        iWidth = (iEndLineNo - iStartLineNo) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - iEndLineNo / 2)
        if (iLeft < 0) {
          iLeft = 0
        }
      }
      //
      if (iFieldNo == 3 || iFieldNo == 9 || iFieldNo == 8 || iFieldNo == 27 || (iFieldNo == 19 && tbCount == 0)) {
        iWidth = ((iEndLineNo + 1) - (iStartLineNo)) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2)
        //
        var idvwidhtst = iImageWidth * Imgs_scale
        XeHeight = iThisFontSize * 1.2
      }
      iWordType = 4
    }
    // 小字三行的处理
    if (iFieldNo == 10) {
      iThisFontSize = iFontSize * 0.5
      iWidth = iThisFontSize
      XeHeight = iWidth * 1.4
      if (iStartLineNo % 2 == 0) {
        if (iEndLineNo == iStartLineNo) { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 * 2 + parseInt(objLine2.style.left) } else { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 + parseInt(objLine2.style.left) }
      } else {
        iLeft = (iRowWidth / 3 - iWidth) / 2 + parseInt(objLine2.style.left)
      }
    }
    // 小小字的处理
    if (iFieldNo == 0) {
      var tiTop = iTop
      if (iileft == 1 && nextThis != iEndLineNo && nextThis != -1) {
        iileft = 0
      }
      if (iileft == 0) { // 右
        iWidth = iRowWidth / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2) + iWidth
        XeHeight = iThisFontSize * 1.2
        iileft++
        // 第一行的时候
        if (nextTop < 0) {
          nextTop = iTop
        } else if (iTopSpace != 0 && i != 0) {
          iTop = IpRowpos
          ipRowFonts = IpRowpos
        }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0) {
          iTop = tiTop
          nextTop = tiTop
        }
        nextThis = iEndLineNo
      } else {
        iWidth = iRowWidth / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2)
        //
        XeHeight = iThisFontSize * 1.2
        iileft = 0
        if (ipRowFonts != -1) { iTop = ipRowFonts }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0 && iStartLineNo % 2 == 1) {
          iTop = tiTop
          nextTop = tiTop
        }
        iLeft += 2
        nextThis = -1
      }
    }
    if (XeHeight < 0) { XeHeight = 1 * iFontSize * 1.2 }
    if (iFontSizeNo != 2) {
      iTop += nextreadNo
    }
    var chilenst = document.getElementById('r' + iRowtsid)
    var ischileFiles = true
    if (itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.1) {
      ischileFiles = false
    }
    // 小小行跨行处理
    if (iFieldNo != 0) {
      iileft = 0
    }
    IpTop = iTop
    if (iFieldNo != 0) {
      nextTop = IpRowpos
    }
    // 小行显示的数据超出下面大行处理
    if (iFontSizeNo == 1) { nextTopmins = nextTopmin }
    var itxtCount = iBottomSpace - iTopSpace
    var isboTop = false
    // 处理大字显示是否变瘦问题
    if ((iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
      if (iBottomSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      } else if (iTopSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      }
    }
    // 改变字体的长度（字变瘦）
    if (itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.0 && iFieldNo != 3) {
      //
      var iTopbks = iTop
      var sOnebk = sOneBlock
      var aspectionblck = 0 // 记录使用的缩放比例
      var aspLinetCount = 0 // 记录括号所占的像素点
      if (IsPagetion) {
        sOnebk = DeleteSubString(sOneBlock, '<txt ', '>')
        while (sOnebk.indexOf('</txt>') > -1) {
          sOnebk = sOnebk.replace('</txt>', '')
        }
      }
      var sOnebks = sOnebk
      var cpsdk = false // 有括号
      if (sOnebks.indexOf('（') > -1 || sOnebks.indexOf('）') > -1) {
        cpsdk = true
      }
      var countbk = 0 // 括号的占比
      while (sOnebks.indexOf('（') > -1) {
        sOnebks = sOnebks.replace('（', '')
        aspLinetCount += 2
        countbk += 2
      }
      while (sOnebks.indexOf('）') > -1) {
        sOnebks = sOnebks.replace('）', '')
        aspLinetCount += 2
        countbk += 2
      }
      if (countbk < 3) {
        countbk = 0
      }
      var itxtCountlength = SplitStringToArray(sOnebks).length
      if (sOnebks == '') {
        itxtCountlength = 0
      }
      var itextSpaces = iFontSize * 1.2
      var itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
      if (itextSpaces != XeHeight || (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        } else {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength + countbk)
        }
      } else {
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength + countbk)
        }
      }
      objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
      aspectionblck = itspaces
      objDivBlock.style.transformOrigin = 'top'
      //
      if ((iBottomSpaces.toString().indexOf('.') > -1)) {
        iTop = iTopSpace * aspectHeight + 5
      }
      iTopbks = iTop
      var isFonLineFss = false
      lastitspacespe = itspaces
      // 处理version2中的数据
      if (IsPagetion && isPagepaces) {
        itspaces = Math.floor(itspaces * 100) / 100
        objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
        aspectionblck = itspaces
        iTop = iTopSpace * aspectHeight + 5
        // 赋值
        onHeightOred(iRowtsids, itspaces)
      }
      // 记录上一行的高度和ts
      lastbuttompa = aspectionblck * (XeHeight * itxtCountlength)
      if (ispost) {
        lastbuttompa = aspectionblck * (XeHeight * itxtCountlength * 0.65)
      }
      lastitspacespe = aspectionblck
      lasttoppa = iTop
      /// ///////////////
    } else {
      iTop = iTopSpace * aspectHeight + 5
    } //
    if (iTop == 0) {
      iTop = 5
    }
    ShowOneString(sOneBlock, iThisFontSize, iWordType, iFormatType, objDivBlock, iLeft, iTop, iWidth, iHeight, sClassName, ispost, XeHeight, iFieldNo)
    if (objParent != null) { objParent.appendChild(objDivBlock) }
    if (iFieldNo != 0) { nextiFieldNo = iStartLineNo }
    if (iFontSizeNo == 1)// 小行显示的数据超出下面大行处理
    {
      nextopst = iTop
      nextTopmin = IpRowpos
    } else { nextTopmin = -1 }
  }
}

// version1的数据（增加了一些标记）
// 用block标记将每一行（字块）标记出来
function ShowOneLineDt (iLineNo, sOneLine, objDivPage, arrayDivRows, iDivPageHeight, iDivPageWidth) {
  var arrayOneLine = new Array(); nextreadNo = 0
  arrayOneLine = sOneLine.split('</bl>')
  var iStartLineNo, iEndLineNo, iTopSpace, iFormatType, iFieldNo, iFontSizeNo, iBlockHeight
  var iLeft, iTop, iWidth, iHeight
  var objParent, objLine, objLine2, objDivBlock
  var iThisLineNo, iThisLineNo2, iThisLineWidth
  var iWordType = 1
  var iThisFontSize = iFontSize
  var sClassName = ''
  var iTopcount = 0, leftcount = -1, itops = -1, iBottomSpace = -1 // 累加顶部的空白字符数的高度
  leftToLine = -1; isFieleTe = false, ipRowFonts = -1
  var iileft = 0, IpTop = 0 // 小小字的处理、超行重叠
  IpRowpos = 0 // 超行重叠处理;
  var nextiFieldNo = -1, nextTop = -1 // 上一行的开始行号，上上一行的高度 //处理大字超出
  var nextTopmin = -1, nextTopmins = -1, istopmin = false, nextopst = -1 /// /上一行的开始行号，上上一行的高度 //处理小行小字超出
  var nextThis = -1 // 小小字的显示记录方式（处理显示）
  var iTopSpaces = '', iBottomSpaces = ''
  var lastitspacespe = -1 // 记录上一行的缩放比例
  var lastbuttompa = -1, lasttoppa = -1 // 记录上一行的高度bs和ts
  var islasttoppace = false
  // 按照文字块进行显示
  for (var i = 0; i < arrayOneLine.length - 1; i++) {
    var sOneBlock = arrayOneLine[i], ispost = false
    iStartLineNo = parseInt(GetOnePara(sOneBlock, 'sl', '0')) // 开始行号
    iEndLineNo = parseInt(GetOnePara(sOneBlock, 'el', '0')) // 结束行号
    iTopSpace = Number(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
    iBottomSpace = Number(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    iTopSpaces = GetOnePara(sOneBlock, 'ts', '0') 	// 与顶部的空白字符数
    iBottomSpaces = GetOnePara(sOneBlock, 'bs', '0') // 顶部到底部的空格字数
    iFormatType = parseInt(GetOnePara(sOneBlock, 'tp', '0')) // 排版格式（与画框相同）
    iFieldNo = parseInt(GetOnePara(sOneBlock, 'fn', '0')) 	// 字段编号（与画框相同）
    iFontSizeNo = parseFloat(GetOnePara(sOneBlock, 'fs', '0')) // 字号大小，小字为1，普通正文文字为2，其它字号为小字的倍数
    iBlockHeight = parseInt(GetOnePara(sOneBlock, 'bh', '0')) // 高度，以小字数为单位
    iRowtsids = GetOnePara(sOneBlock, 'rid', '0') // 具体行的id
    // 判断
    if (aspectratio <= 1) {
      iTopSpace = parseInt(GetOnePara(sOneBlock, 'ts', '0')) 	// 与顶部的空白字符数
      iBottomSpace = parseInt(GetOnePara(sOneBlock, 'bs', '0')) // 顶部到底部的空格字数
    }
    sOneBlock = DeleteSubString(sOneBlock, '<bl ', '>')
    objDivBlock = document.createElement('div')

    //
    iThisFontSize = iFontSize * iFontSizeNo / 2
    iThisLineNo = parseInt(iStartLineNo / 2)
    iThisLineNo2 = parseInt(iEndLineNo / 2)
    objLine = arrayDivRows[iThisLineNo]
    objLine2 = arrayDivRows[iThisLineNo2]
    objParent = arrayDivRows[iThisLineNo]
    iThisLineWidth = parseInt(iDivPageWidth)
    if (iFieldNo == 3) { iThisFontSize = (iThisFontSize * 0.6) * iSMScale } // iThisFontSize字
    else if (iFieldNo == 8) { iThisFontSize = (iThisFontSize * 0.6) * iTBScale } else if (iFieldNo == 9) { iThisFontSize = (iThisFontSize * 0.6) * iBTScale } else if (iFieldNo == 27) { iThisFontSize = (iThisFontSize * 0.6) * iTSScale }
    // 小字处理
    if (iFontSizeNo == 1) { iThisFontSize = iFontSize * 0.65 }
    // 小小字的处理
    if (iFieldNo == 0) { iThisFontSize = (iFontSize * 0.7) * 0.6 }
    var XeHeight = -1
    iHeight = -1
    // 顶部距离处理
    iTop = iTopSpace * iFontSize * 1.2
    iTop += 5
    // 正文
    if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0) {
      // 没有跨行，大字正文
      iLeft = (iThisLineWidth - iThisFontSize) / 2
      iWidth = iThisFontSize
      iWordType = 1
      objDivBlock.className = 'div_block_bigzw'
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 0) {
      // 没有跨行，小字正文，右边行
      iLeft = iThisLineWidth / 2 + 2
      iWidth = iThisFontSize
      iWordType = 2
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
    } else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
      // 没有跨行，小字正文，左边行
      iLeft = iThisLineWidth / 2 - iThisFontSize - 2
      iWidth = iThisFontSize
      iWordType = 3
      objDivBlock.className = 'div_block_smallzw'
      ispost = true
      if (iLeft + iWidth >= iRowWidth - 1) {
        iLeft = iRowWidth - iWidth - 2
      } else if (iLeft < 1) {
        iLeft = 2
      }
      if ((iEndLineNo / 2 == DivRowCount - 1 || iStartLineNo / 2 == DivRowCount - 1) && iLeft < 4) {
        iLeft = 5
      }
    } else {
      objParent = objDivPage
      // 有跨行，或其它字段
      if (iEndLineNo % 2 == 0) {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + parseInt(objLine2.style.width) / 2 + 1 }
      } else {
        if (objLine2 != null) { iLeft = parseInt(objLine2.style.left) + 1 }
      }
      if (iStartLineNo % 2 == 0) {
        if (objLine != null) { iWidth = parseInt(objLine.style.width) * 0.65 }
      } else if (objLine != null) {
        iWidth = parseInt(objLine.style.left) - iLeft + parseInt(objLine.style.width) / 2 - 2
        iWidth /= 2
      }

      if (iFieldNo == 3) { objDivBlock.className = 'div_block_bookname' } else if (iFieldNo == 8) { objDivBlock.className = 'div_block_imgbt' } else if (iFieldNo == 9) { objDivBlock.className = 'div_block_title' } else if (iFieldNo == 27) { objDivBlock.className = 'div_block_imgsm' } else if (iFieldNo == 19) {
        objDivBlock.className = 'div_insert'
        iHeight = parseInt(iBlockHeight * iFontSize * 1.2 + 0.4)
      }
      if (iFieldNo != 27 && iFieldNo != 19 && (iFormatType == 1 || iFormatType == 2) && iFieldNo != 3) {
        // 竖版，则将宽度限定为字宽
        iLeft = iLeft + (iWidth - iThisFontSize) / 2
        iWidth = iThisFontSize
      }
      // 插图处理
      if (iFieldNo == 19) {
        iWidth = (iEndLineNo - iStartLineNo) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - iEndLineNo / 2)
        if (iLeft < 0) {
          iLeft = 0
        }
      }
      //
      if (iFieldNo == 3 || iFieldNo == 9 || iFieldNo == 8 || iFieldNo == 27 || (iFieldNo == 19 && tbCount == 0)) {
        iWidth = ((iEndLineNo + 1) - (iStartLineNo)) / 2 * iRowWidth
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2)
        //
        var idvwidhtst = iImageWidth * Imgs_scale
        XeHeight = iThisFontSize * 1.2
      }
      iWordType = 4
    }
    // 小字三行的处理
    if (iFieldNo == 10) {
      iThisFontSize = iFontSize * 0.5
      iWidth = iThisFontSize
      XeHeight = iWidth * 1.4
      if (iStartLineNo % 2 == 0) {
        if (iEndLineNo == iStartLineNo) { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 * 2 + parseInt(objLine2.style.left) } else { iLeft = (iRowWidth / 3 - iWidth) / 2 + iRowWidth / 3 + parseInt(objLine2.style.left) }
      } else {
        iLeft = (iRowWidth / 3 - iWidth) / 2 + parseInt(objLine2.style.left)
      }
    }
    // 小小字的处理
    if (iFieldNo == 0) {
      var tiTop = iTop
      if (iileft == 1 && nextThis != iEndLineNo && nextThis != -1) {
        iileft = 0
      }
      if (iileft == 0) { // 右
        iWidth = iRowWidth / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2) + iWidth
        XeHeight = iThisFontSize * 1.2
        iileft++
        // 第一行的时候
        if (nextTop < 0) {
          nextTop = iTop
        } else if (iTopSpace != 0 && i != 0) {
          iTop = IpRowpos
          ipRowFonts = IpRowpos
        }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0) {
          iTop = tiTop
          nextTop = tiTop
        }
        nextThis = iEndLineNo
      } else {
        iWidth = iRowWidth / 4
        iLeft = iRowWidth * (DivRowCount - (iEndLineNo + 1) / 2)
        //
        XeHeight = iThisFontSize * 1.2
        iileft = 0
        if (ipRowFonts != -1) { iTop = ipRowFonts }
        // 两小行的特殊处理
        if (nextiFieldNo != iStartLineNo) {
          iTop = nextTop
        }
        // （有字变瘦）情况处理
        if (iBottomSpace > 0 && iStartLineNo % 2 == 1) {
          iTop = tiTop
          nextTop = tiTop
        }
        iLeft += 2
        nextThis = -1
      }
    }
    if (XeHeight < 0) { XeHeight = 1 * iFontSize * 1.2 }
    if (iFontSizeNo != 2) {
      iTop += nextreadNo
    }
    var chilenst = document.getElementById('r' + iRowtsid)
    var ischileFiles = true
    if (itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.1) {
      ischileFiles = false
    }
    // 上一行与这一行重叠处理大行
    if (ischileFiles && chilenst != null && (nextiFieldNo == iStartLineNo || nextiFieldNo == iStartLineNo - 1 || nextiFieldNo == iStartLineNo + 1) && IpRowpos > (iTop) && (iTop - IpTop) > 0 && (iFieldNo == 17 || iFieldNo == 27) && iFontSizeNo == 2) {
      chilens = chilenst.childNodes
      var Chilheight = (iTop - IpTop) / chilens.length
      for (var k = 0; k < chilens.length; k++) {
        chilens[k].style.height = Chilheight + 'px'
        chilens[k].style.lineHeight = Chilheight + 'px'
        if ($(chilens[k]).width() > Chilheight) {
          $(chilens[k]).width(Chilheight)
        }
      }
      var fontHeightsize = Number(chilenst.style.fontSize.replace('px', ''))
      chilenst.style.fontSize = (Number(Chilheight) / 1.1) + 'px'
      chilenst.style.transform = ''
      var chilensts = document.getElementById('r' + (iRowtsid - 1))
      // 两小行处理
      if (chilensts != null && chilenst.className == 'div_block_smallzw') {
        if (chilensts.className == 'div_block_smallzw') {
          chilens = chilensts.childNodes
          Chilheight = (iTop - IpTop) / chilens.length
          for (var k = 0; k < chilens.length; k++) {
            chilens[k].style.height = Chilheight + 'px'
            chilens[k].style.lineHeight = Chilheight + 'px'
            if ($(chilens[k]).width() > Chilheight) {
              $(chilens[k]).width(Chilheight)
            }
          }
          chilensts.style.fontSize = (Number(Chilheight) / 1.1) + 'px'
          chilensts.style.transform = ''
        }
      }
    }
    // 小小行跨行处理
    if (iFieldNo != 0) {
      iileft = 0
    }
    IpTop = iTop
    if (iFieldNo != 0) {
      nextTop = IpRowpos
    }
    // 小行显示的数据超出下面大行处理
    if (iFontSizeNo == 1) { nextTopmins = nextTopmin }
    // 小行显示的数据超出下面大行处理
    if (iFontSizeNo == 17 && nextTopmin != -1 && nextTopmins != -1 && (nextTopmin > iTop || nextTopmins > iTop)) {
      var iptops = nextTopmins
      if (nextTopmin > iptops) {
        iptops = nextTopmin
      }
      minRowpos(iRowtsid, iTop, iTop - nextopst)
    }
    var itxtCount = iBottomSpace - iTopSpace
    var isboTop = false
    // 处理大字显示是否变瘦问题
    if ((iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
      if (iBottomSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      } else if (iTopSpaces.toString().indexOf('.') > -1) {
        isboTop = true
      }
    }
    // 改变字体的长度（字变瘦）
    if (itxtCount > 0 && iBottomSpace > 0 && aspectratio > 1.0 && iFieldNo != 3) {
      //
      var iTopbks = iTop
      var sOnebk = sOneBlock
      var aspectionblck = 0 // 记录使用的缩放比例
      var aspLinetCount = 0 // 记录括号所占的像素点
      if (IsPagetion) {
        sOnebk = DeleteSubString(sOneBlock, '<txt ', '>')
        while (sOnebk.indexOf('</txt>') > -1) {
          sOnebk = sOnebk.replace('</txt>', '')
        }
      }
      var sOnebks = sOnebk
      var cpsdk = false // 有括号
      if (sOnebks.indexOf('（') > -1 || sOnebks.indexOf('）') > -1) {
        cpsdk = true
      }
      while (sOnebks.indexOf('（') > -1) {
        sOnebks = sOnebks.replace('（', '')
        aspLinetCount += 2
      }
      while (sOnebks.indexOf('）') > -1) {
        sOnebks = sOnebks.replace('）', '')
        aspLinetCount += 2
      }
      var itxtCountlength = SplitStringToArray(sOnebks).length
      if (sOnebks == '') {
        itxtCountlength = 0
      }
      var itextSpaces = iFontSize * 1.2
      var itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength)
      if (itextSpaces != XeHeight || (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
        // itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength);
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength)
        } else {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * itxtCountlength)
        }
      } else {
        // 处理bs小于实际字数
        if (aspectHeight > 0 && iBottomSpace < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength)
        } else if (iBottomSpaces.toString().indexOf('.') > -1) {
          itextSpaces = aspectHeight
          itspaces = (itextSpaces * itxtCount) / (XeHeight * 0.65 * itxtCountlength)
        }
      }
      objDivBlock.style.transform = 'scaleY(' + itspaces + ')'
      aspectionblck = itspaces
      objDivBlock.style.transformOrigin = 'top'
      //
      if ((iBottomSpaces.toString().indexOf('.') > -1)) {
        iTop = iTopSpace * aspectHeight
      }
      iTopbks = iTop
      // 判断是否全是小字的(小字对齐)iFieldNo == 17 && iEndLineNo - iStartLineNo == 0
      if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && toArrayitspaces > 0) {
        objDivBlock.style.transform = 'scaleY(' + toArrayitspaces + ')'
        iTop = 5 + (toArrayitspaces * XeHeight * 0.65) * iTopSpace
        aspectionblck = toArrayitspaces
        if (toArrayitspacNo != 0) {
          iTop = 5 + iTopSpace * aspectHeight
        }
      }
      var isFonLineFss = false
      // 判断是全是大字的(toArrayitspacNo)
      if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0) {
        if (toArrayitspacNo != 0) {
          objDivBlock.style.transform = 'scaleY(' + toArrayitspacNo + ')'
          aspectionblck = toArrayitspacNo
          //
          if (iTop != 0) {
            iTop = iTopSpace * aspectHeight + 5
          }
          isFonLineFss = true
        }
      }
      // 判断大字压小字
      if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0) {
        if (lastbuttompa + lasttoppa > 5 && (lastbuttompa + lasttoppa > iTop - 5)) {
          lastbuttompa = lastitspaces * (XeHeight * itxtCountlength)
          // lasttoppa左边小行
          var theill = 0
          var toplast = iTop
          var lastchilenst = document.getElementById('r' + iRowtsid)
          var lastchilen = lastchilenst.childNodes[0]
          var lastheight = 0 // Number(lastchilen.style.height.replace("px", "")) * lastchilenst.childNodes.length;
          for (var p = 0; p < lastchilenst.childNodes.length; p++) {
            var bbiName = lastchilenst.childNodes[p].className
            if (bbiName != 'mypart') {
              // style="cc"
              for (var j = 0; j < lastchilenst.childNodes[p].childNodes.length; j++) {
                lastheight += Number(lastchilenst.childNodes[p].childNodes[j].style.height.replace('px', ''))
              }
              theill += 4
            } else {
              lastheight += Number(lastchilenst.childNodes[p].style.height.replace('px', ''))
            }
          }
          var lastitspaces = ((toplast) - lasttoppa) / (lastheight + theill)
          if (lastitspaces > 0) {
            lastchilenst.style.transform = 'scaleY(' + lastitspaces + ')'
            isFonLineFss = true
          }
        }
      }
      // 判断是否是与上一行重叠（拉伸后的小字）
      if (islasttoppace && (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0)) {
        if (lastbuttompa + lasttoppa > 5 && (lastbuttompa + lasttoppa > iTop - 5)) {
          // lasttoppa左边小行
          var toplast = iTop
          var lastchilenst = document.getElementById('r' + iRowtsid)
          var lastchilen = lastchilenst.childNodes[0]
          var lastheight = 0
          for (var p = 0; p < lastchilenst.childNodes.length; p++) {
            var bbiName = lastchilenst.childNodes[p].className
            if (bbiName != 'mypart') {
              // style="cc"
              for (var j = 0; j < lastchilenst.childNodes[p].childNodes.length; j++) {
                lastheight += Number(lastchilenst.childNodes[p].childNodes[j].style.height.replace('px', ''))
              }
              theill += 4
            } else {
              lastheight += Number(lastchilenst.childNodes[p].style.height.replace('px', ''))
            }
          }
          var lastitspaces = ((toplast) - lasttoppa) / (lastheight + theill)
          lastchilenst.style.transform = 'scaleY(' + lastitspaces + ')'
          // 右边小行
          var lastchilensts = document.getElementById('r' + (iRowtsid - 1))
          lastchilensts.style.transform = 'scaleY(' + lastitspaces + ')'
        }
        // 右边超出距离的时候
        var lastschil = document.getElementById('r' + (iRowtsid - 1))
        if (lastschil != null) {
          var ipbuttompa = 0 // lastschil.style.top.replace("px", "");
          var iptoppa = lastschil.style.top.replace('px', '')
          var ipspaces = lastschil.style.transform.replace('scaleY(', '')
          ipspaces = ipspaces.replace(')', '')
          ipbuttompa = Number(ipbuttompa)
          iptoppa = Number(iptoppa)
          ipspaces = Number(ipspaces)
          var lastheight = 0, theill = 0
          for (var p = 0; p < lastschil.childNodes.length; p++) {
            var bbiName = lastschil.childNodes[p].className
            if (bbiName != 'mypart') {
              // style="cc"
              for (var j = 0; j < lastschil.childNodes[p].childNodes.length; j++) {
                lastheight += Number(lastschil.childNodes[p].childNodes[j].style.height.replace('px', ''))
              }
              theill += 4
            } else {
              lastheight += Number(lastschil.childNodes[p].style.height.replace('px', ''))
            }
          }
          var ipbuttompas = lastheight * ipspaces
          lastheight += theill
          ipbuttompa += ipbuttompas
          //
          if (ipbuttompa + iptoppa > 5 && (ipbuttompa + iptoppa > iTop - 5)) {
            // 右边小行
            var lastitspaces = ((iTop) - iptoppa) / (lastheight + theill)
            lastschil.style.transform = 'scaleY(' + lastitspaces + ')'
            // 左边小行
            var lastchilensts = document.getElementById('r' + (iRowtsid))
            lastchilensts.style.transform = 'scaleY(' + lastitspaces + ')'
          }
        }
        islasttoppace = false
      }
      // 判断是否是与上一行重叠（拉伸后的大字）
      else if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 1 && iStartLineNo % 2 == 0) {
        if (lastbuttompa + lasttoppa > 5 && (lastbuttompa + lasttoppa > iTop - 5)) {
          // lasttoppa左边小行
          var toplast = iTop
          var lastchilenst = document.getElementById('r' + iRowtsid)
          var lastchilen = lastchilenst.childNodes[0]
          var lastheight = 0, theill = 0
          for (var p = 0; p < lastchilenst.childNodes.length; p++) {
            var bbiName = lastchilenst.childNodes[p].className
            if (bbiName != 'mypart') {
              // style="cc"
              for (var j = 0; j < lastchilenst.childNodes[p].childNodes.length; j++) {
                lastheight += Number(lastchilenst.childNodes[p].childNodes[j].style.height.replace('px', ''))
              }
              theill += 4
            } else {
              lastheight += Number(lastchilenst.childNodes[p].style.height.replace('px', ''))
            }
          }
          var lastitspaces = ((toplast) - lasttoppa) / (lastheight + theill)
          lastchilenst.style.transform = 'scaleY(' + lastitspaces + ')'
          lastitspacespe = lastitspaces
        }
      }
      // 小行左边（显示左边与右边对齐）
      if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
        var lastchilenst = document.getElementById('r' + iRowtsid)
        var lastClassName = ''
        if (lastchilenst != null) { lastClassName = lastchilenst.className }
        if (lastitspacespe > 0 && lastClassName == 'div_block_smallzw') {
          objDivBlock.style.transform = 'scaleY(' + lastitspacespe + ')'
          aspectionblck = lastitspacespe
        }
        islasttoppace = true
      }
      lastitspacespe = itspaces
      // 记录上一行的高度和ts
      lastbuttompa = lastitspacespe * (XeHeight * itxtCountlength)
      lasttoppa = iTop
      if (ispost) {
        lastbuttompa = lastitspacespe * (XeHeight * itxtCountlength * 0.65)
      }
      /// ///////////////
      /// /判断上一行出了界线
      if (iTop == 0) {
        iTop = 5
      }
      var numberheight = 0
      var numhelength = 0 // 实际高度
      if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0) {
        // 小行
        numhelength = (XeHeight * 0.65 * itxtCountlength) + aspLinetCount
        numberheight = iTop + (XeHeight * 0.65 * itxtCountlength * aspectionblck) + aspLinetCount
      } else {
        // 其他
        numhelength = (XeHeight * itxtCountlength) + aspLinetCount
        numberheight = iTop + (XeHeight * itxtCountlength * aspectionblck) + aspLinetCount
      }
      var numberHe = ItextHeightpage // aspectHeight * MaxButtomHe;
      // 调整位置
      var numberItext = numhelength * aspectionblck + iTop
      var numberItexts = numhelength * aspectionblck + iTopbks
      // 判断是否超出、
      if (numberheight - (numberHe + 5) > 1.5) {
        // 重算拉伸比例
        var itspaceed = (numberHe - iTop) / (numhelength)
        objDivBlock.style.transform = 'scaleY(' + itspaceed + ')'
        aspectionblck = itspaceed
        // 如何使左边小行也一起改变
        if (iFieldNo == 17 && iEndLineNo - iStartLineNo == 0 && iStartLineNo % 2 == 1) {
          var lastchilenst = document.getElementById('r' + iRowtsid)
          if (lastchilenst.className == 'div_block_smallzw') {
            lastchilenst.style.transform = 'scaleY(' + itspaceed + ')'
          }
        }
        lastitspacespe = itspaceed
      }
      // 记录上一行的高度和ts
      lastbuttompa = aspectionblck * (XeHeight * itxtCountlength)
      if (ispost) {
        lastbuttompa = aspectionblck * (XeHeight * itxtCountlength * 0.65)
      }
      lastitspacespe = aspectionblck
      lasttoppa = iTop
    } else {
      iTop = iTopSpace * aspectHeight + 5
    } //
    if (iTop == 0) {
      iTop = 5
    }
    ShowOneString(sOneBlock, iThisFontSize, iWordType, iFormatType, objDivBlock, iLeft, iTop, iWidth, iHeight, sClassName, ispost, XeHeight, iFieldNo)
    if (objParent != null) { objParent.appendChild(objDivBlock) }
    if (iFieldNo != 0) { nextiFieldNo = iStartLineNo }
    if (iFontSizeNo == 1)// 小行显示的数据超出下面大行处理
    {
      nextopst = iTop
      nextTopmin = IpRowpos
    } else { nextTopmin = -1 }
  }
}
// 处理小行的数据超出大字
function minRowpos (iRowtsid, iTop, IpTop) {
  var isfontbls = false
  var chilens = document.getElementById('r' + iRowtsid).childNodes
  var Chilheight = IpTop / chilens.length
  for (var i = 0; i < chilens.length; i++) {
    chilens[i].style.height = Chilheight + 'px'
    chilens[i].style.lineHeight = Chilheight + 'px'
    // 如果超出间距太小字体变小
    if (Chilheight < 10) {
      isfontbls = true
    }
  }
  var chilens = document.getElementById('r' + (iRowtsid - 1)).childNodes
  var Chilheight = IpTop / chilens.length
  for (var i = 0; i < chilens.length; i++) {
    chilens[i].style.height = Chilheight + 'px'
    chilens[i].style.lineHeight = Chilheight + 'px'
    // 如果超出间距太小字体变小
    if (Chilheight < 20) {
      isfontbls = true
    }
  }
  // 如果超出间距太小字体变小
  if (isfontbls) {
    var isRowsfon = document.getElementById('r' + iRowtsid)
    var isRowsfons = document.getElementById('r' + (iRowtsid - 1))
    var isRowsfonsize = isRowsfon.style.fontSize
    isRowsfonsize = isRowsfonsize.substring(0, (isRowsfonsize.length - 2))
    var isRowsfonsizes = isRowsfons.style.fontSize
    isRowsfonsizes = isRowsfonsizes.substring(0, (isRowsfonsizes.length - 2))
    var fontsiz = Number(isRowsfonsize) / 1.5
    document.getElementById('r' + iRowtsid).style.fontSize = (fontsiz) + 'px'
    document.getElementById('r' + (iRowtsid - 1)).style.fontSize = (Number(isRowsfonsizes) / 1.5) + 'px'
  }
}
/* 显示一个字符串
sOneString:需要显示的字符串
objDiv:需要显示的DIV
iLeft、iTop:显示坐标左上角
iWidth、iHeight:显示框的宽度和高度
iFontSize:需要显示的字号
iFormatType:版式，0：左起横版，1：右起竖版，2：左起竖版，3：右起横版
ispost:区别大小行
ileft:调整位置
*/
function ShowOneString (sOneString, iThisFontSize, iWordType, iFormatType, objDiv, iLeft, iTop, iWidth, iHeight, sClassName, ispost, XeHeight, iFieldNo) {
  var arrarWords = []
  if (IsPagetion) {
    if (sOneString.indexOf('</txt>') > 0) {
      arrarWords = sOneString.split('</txt>')
    }
  } else {
    arrarWords = SplitStringToArray(sOneString)
  }
  if (iFieldNo != 0) { IpRowpos = iTop }
  var iWordCount = arrarWords.length

  //
  if (sClassName.length > 0) { objDiv.className = sClassName }
  //
  if (ispost) {
    XeHeight = XeHeight * 0.65
  }
  //
  // 插图
  objDiv.style.position = 'absolute'
  objDiv.style.top = iTop + 'px'
  objDiv.style.left = iLeft + 'px'
  //
  if (iWidth > 0) { objDiv.style.width = iWidth + 'px' }
  if (iHeight > 0) { objDiv.style.height = iHeight + 'px' }
  objDiv.style.fontSize = iThisFontSize + 'px'
  var bInvert = false
  var iLetterSpacing = 0
  var iLineHeight = iThisFontSize

  if (iFormatType == 0) {
    // 左起横版
    iLetterSpacing = iWidth / iWordCount - iThisFontSize - 1
  } else if (iFormatType == 1) {
    // 右起竖版
    objDiv.style.width = iWidth + 'px'
  } else if (iFormatType == 2) {
    // 右起竖版
    objDiv.style.width = iWidth + 'px'
  } else if (iFormatType == 3) {
    // 右起横版
    iLetterSpacing = iWidth / iWordCount - iThisFontSize - 1
    bInvert = true
  }
  objDiv.style.letterSpacing = iLetterSpacing + 'px'
  sOneString = ArrayToString(arrarWords, iWordType, bInvert)
  //
  if (iWordType == 1) { objDiv.style.cssFloat = 'left' }
  //
  var sOnebk = sOneString
  if (IsPagetion) {
    sOnebk = DeleteSubString(sOneString, '<txt ', '>')
    while (sOnebk.indexOf('</txt>') > -1) {
      sOnebk = sOnebk.replace('</txt>', '')
    }
  }
  if (sOnebk.indexOf('[IMG=') >= 0) {
    // 插图
    var sImgFn = GetOnePara(sOnebk, '[IMG', '')
    if (sImgFn.substr(sImgFn.length - 1) == ']') { sImgFn = sImgFn.substr(0, sImgFn.length - 1) }
    var xiHeights = txMaxSize * XeHeight - iTop
    iHeight *= 0.85
    if (iHeight > ItextHeightpage - iTop) { iHeight = ItextHeightpage - iTop - 1 }
    objDiv.style.width = iWidth + 'px'
    objDiv.style.height = iHeight + 'px'
    objDiv.style.fontSize = '0px'
    if (XeHeight > ItextHeightpage - iTop) { XeHeight = ItextHeightpage - iTop - 1 }
    if (version == 3) {
      objDiv.style.height = XeHeight + 'px'
      sOneString = '<img class=mypart src=' + sCurInsetPath + sImgFn + '.jpg width="' + (iWidth) + 'px"  height="' + XeHeight + 'px" >'
    } else if (iHeight < 1) {
      objDiv.style.height = '10px' // 默认值
      sOneString = '<img class=mypart src=' + sCurInsetPath + sImgFn + '.jpg width="' + (iWidth) + 'px" >'
    } else {
      sOneString = '<img class=mypart src=' + sCurInsetPath + sImgFn + '.jpg width="' + (iWidth) + 'px"  height="' + (iHeight - 4) + 'px" >'
    }
    objDiv.style.transform = ''
  } else {
    var ispageWords = ''
    if (!IsPagetion) {
      arrarWords = SplitStringToArray(sOneString)
    } else {
      if (arrarWords.length > 1) {
        arrarWords.length = arrarWords.length - 1
      }
      ispageWords = ArrayToString(sOnebk, iWordType, bInvert)
      ispageWords = SplitStringToArray(ispageWords)
    }
    sOneString = ''
    var txtprade = ''
    var txtwCount = 0 // 括号的次数
    var txtstart = -1 // 开始括号下面出现的字数
    for (var i = 0; i < arrarWords.length; i++) {
      iFontsids = GetOnePara(arrarWords[i], 'sid', '0')
      if (iFontsids == '0' && IsPagetion) {
        continue
      }
      var txt = arrarWords[i]
      if (IsPagetion) { txt = DeleteSubString(arrarWords[i], '<txt ', '>') }
      if (txt == '䶻') {
        txt = ''
      }
      // 判断（）的
      if (txt.indexOf('（') > -1) {
        txtprade = "<div class='note_top_words'style='cc'>"
        istextw = 1; txtwCount++
        sOneString += txtprade
        txtstart = 1
        continue
      }
      if (txt.indexOf('）') > -1) {
        if (sOneString == '') { // 特殊：双小字括号
          sOneString = "<div class='note_bottom_words' style='height:10px;position:absolute;top:-13px;width:" + iWidth + "px;'>" + sOneString
        } else {
          if (sOneString.indexOf('note_top_words') > -1) {
            sOneString = sOneString.replace('note_top_words', 'note_words')
          } else {
            sOneString = "<div class='note_bottom_words'>" + sOneString
          }
        }
        txtprade = '</div>'
        istextw = 2; txtwCount++
        sOneString += txtprade
        continue
      }
      // 判断文章的插图
      if (txt.indexOf('<IMG') >= 0 && !IsPagetion) {
        txt = txt.substring(0, txt.length - 1) + ' width="' + (XeHeight / 1.2) + 'px"  height="' + XeHeight + 'px" >'
      } else if (ispageWords != '') {
        if (ispageWords[i].indexOf('<IMG') >= 0) { txt = ispageWords[i].substring(0, ispageWords[i].length - 1) + ' width="' + (XeHeight / 1.2) + 'px"  height="' + XeHeight + 'px" >' }
      }
      iFontsid++
      if (IsPagetion) {
        sOneString += '<div class=mypart id=' + iFontsids + ' style="line-height:' + XeHeight + 'px; width:' + iWidth + 'px; height:' + XeHeight + 'px">' + txt + '</div>'
      } else {
        sOneString += '<div class=mypart id=s' + iFontsid + ' style="line-height:' + XeHeight + 'px; width:' + iWidth + 'px; height:' + XeHeight + 'px">' + txt + '</div>'
      }
      txtprade = ''
      if (iFieldNo != 0) { IpRowpos += XeHeight }
      if (txtstart != -1) {
        txtstart++
      }
    }
    if (istextw == 1) { sOneString = sOneString + '</div>' }
    // 开始括号对应小字的数据
    if (arrarWords[0].indexOf('（') == -1 && sOneString.indexOf('note_top_words') > -1 && txtstart == 1) {
      sOneString = sOneString.replace("style='cc'", "style='height:10px;position:absolute;width:" + iWidth + "px;'")
    } else if (sOneString.indexOf('note_top_words') > -1 && txtstart == 1) {
      sOneString = sOneString.replace("style='cc'", "style='height:10px;position:absolute;top:-4px;width:" + iWidth + "px;'")
    }
    if (objDiv.className == 'div_block_bigzw') {
      nextreadNo += txtwCount * 2 // 括号占位
    }
  }
  iRowtsid++
  objDiv.innerHTML = sOneString
  objDiv.id = 'r' + iRowtsid
  if (IsPagetion && iRowtsids != '') {
    objDiv.id = iRowtsids
  }
  if (txtwCount == 0 && istextw == 1) {
    objDiv.style.color = '#AA0000' // 括号的结尾处理
  }
}

// 将一个字符串按字拆分为数组（需要考虑有造字，以及四字节Unicode字）
function SplitStringToArray (sString) {
  var arrayWords = new Array()
  var bHtmlTag = false
  var sOneChar
  var iWordCount = 0
  var i
  arrayWords[iWordCount] = ''
  for (i = 0; i < sString.length; i++) {
    sOneChar = sString.charAt(i)
    arrayWords[iWordCount] += sOneChar
    if (sOneChar == '<') {
      bHtmlTag = true
    } else if (sOneChar == '>') {
      bHtmlTag = false
    } else if (IsUnicode32(sOneChar)) {
      i++
      arrayWords[iWordCount] += sString.charAt(i)
    }
    if (i == sString.length - 1) { break }
    if (!bHtmlTag) {
      iWordCount++
      arrayWords[iWordCount] = ''
    }
  }
  return arrayWords
}

// 将一个数组拼接为一个字符串
// bInverted:为true表示倒序
function ArrayToString (arrayWords, iWordType, bInverted) {
  var sRet = ''
  var iLen = arrayWords.length
  var i
  var sOneWord
  var sZaoZiClass
  if (iWordType == 2 || iWordType == 3) { sZoaZiClass = 'zaozi_small' } else { sZoaZiClass = 'zaozi_big' }
  var iNoteStart = -1
  for (i = 0; i < iLen; i++) {
    if (bInverted) { sOneWord = arrayWords[iLen - i - 1] } else { sOneWord = arrayWords[i] }
    if (sOneWord.substr(0, 4) == '<IMG') {
      // 处理造字
      sOneWord = sOneWord.substring(5, sOneWord.length - 1)
      sOneWord = '<IMG class="' + sZoaZiClass + '"' + ' src="' + sCurInsetPath + sOneWord + '.jpg">'
    }
    if (sOneWord == '★') {
      iZaoZiCount++
      sOneWord = page + 'Z' + GetZaoZiNumber(iZaoZiCount) + '.jpg'
      var httpRequest = new XMLHttpRequest()// 第一步：建立所需的对象
      let url = '/retrieve/page/getXMLImage?path=' + sOneWord
      httpRequest.open('GET', url, true)// 第二步：打开连接  将请求参数写在url中  ps:"http://localhost:8080/rest/xxx"
      httpRequest.send()// 第三步：发送请求  将请求参数写在URL中
      /**
             * 获取数据后的处理程序
             */
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState == 4 && httpRequest.status == 200) {
          var json = httpRequest.responseText// 获取到json字符串，还需解析
          const binaryData = []
          binaryData.push(json)
          const url = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'image/jpg' })
          )
        }
      }
      sOneWord = '<IMG class="' + sZoaZiClass + '"' + ' src=' + url + '>'
    }

    sRet += sOneWord
  }
  if (iNoteStart == 1) {
    // 注释没有结束括号
    sRet += '</div>'
  }
  return sRet
}

// 判断一个字符是否为四字节字符
function IsUnicode32 (sChar) {
  if (sChar.length == 0) { return false }
  var iCode = sChar.charCodeAt(0)
  if (iCode >= 0xd800 && iCode <= 0xdbff) { return true } else { return false }
}
/// //////////////////////////////////////////////////////////////////////

// 显示一行
function ShowOneLine (iLineNo, sOneLine, objDivRow_Line, iDivPageHeight) {
  sOneLine = sOneLine.replace('<mark type="select.start" kind="SELECT"></mark>', '')
  sOneLine = sOneLine.replace('<mark type="select.end"></mark>', '')

  if (sOneLine.indexOf('<mark') >= 0) {
    // 行中有标记，分析行中的具体内容，结果保存到objDivRow_Line中
    ParseOneLine(objDivRow_Line, sOneLine)
  } else {
    if (sOneLine.length != 0) {
      // 无标记，直接放到一行的div中
      var objDivRow = document.createElement('div')
      objDivRow.className = 'div_row_words'
      objDivRow.style.left = (iRowWidth - iFontSize) / 2 + 'px'
      objDivRow.style.height = (iDivPageHeight - 12) + 'px'
      objDivRow.style.width = iFontSize + 'px'
      objDivRow.style.fontSize = iFontSize + 'px'
      objDivRow_Line.appendChild(objDivRow)
      sOneLine = ReplaceNotesAndZaozi(sOneLine, 0)
      sOneLine = sOneLine.replace(cTurnRed, '<font color=red>' + cTurnRed + '</font>')
      sOneLine = sOneLine.replace(cTurnRedFt, '<font color=red>' + cTurnRedFt + '</font>')
      objDivRow.innerHTML = sOneLine
    }
  }
}

// 行中有标记，分析一行的各个部分
function ParseOneLine (objDivRow, sOneLine) {
  var arrayOneLine = new Array()
  SplitOneLine(arrayOneLine, sOneLine)

  var i
  var sOnePart
  // 对于有两行并列的情况，判断第二行比第一行长时，在第一行后面补上空格,使得第一行的长度不会小于第二行的长度

  var iLen
  for (i = 0; i < arrayOneLine.length; i++) {
    sOnePart = arrayOneLine[i]
    if (sOnePart.indexOf('type="sbr"') >= 0) {
      var sLine2 = arrayOneLine[i + 1]
      sLine2 = sLine2.replace('<mark type="small.end">', '')
      iLen = sLine2.length
      sOnePart = arrayOneLine[i - 1]
      if (sOnePart.length < iLen) {
        while (sOnePart.length < iLen) {
          sOnePart += '䶻'
        }
        arrayOneLine[i - 1] = sOnePart
      }
    }
  }

  var iDivWidth, iDivLeft, iPartFontSize
  iDivLeft = 0
  iDivWidth = iRowWidth
  iPartFontSize = iFontSize
  var iDivHeight = 0
  var objPart
  var iType = 0 // 该行中每一部分的类型，0：正常文本，1：标题，2：并列小文字的第一列，3：并列小文字的第二列
  // 分析一行的每一部分
  for (i = 0; i < arrayOneLine.length; i++) {
    sOnePart = arrayOneLine[i]
    if (sOnePart == '<mark type="image">') { continue }
    if (sOnePart.indexOf('type="title.start"') >= 0) {
      // 标题开始
      iType = 1
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize * 1.2
    } else if (sOnePart.indexOf('type="title.end"') >= 0) {
      // 标题结束
      iType = 0
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize
    } else if (sOnePart.indexOf('type="small.start"') >= 0) {
      // 并列的小文字开始
      iType = 2
      iDivLeft = iRowWidth / 2 + 1
      iDivWidth = iFontSize * 0.65
      iPartFontSize = iFontSize * 0.6 // 小字，显示为大字的60%宽度
    } else if (sOnePart.indexOf('type="sbr"') >= 0) {
      // 并列的第二列小文字开始
      iType = 3
      iDivWidth = iFontSize * 0.65
      iPartFontSize = iFontSize * 0.6
      iDivLeft = iRowWidth / 2 - iPartFontSize - 1
    } else if (sOnePart.indexOf('type="small.end"') >= 0) {
      // 并列的小文字结束
      iType = 0
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize
    } else if (sOnePart.indexOf('<img ') >= 0) {
      // 插图
      sImgFn = GetOnePara(sOnePart, 'src', '')
      iImgWidth = parseInt(GetOnePara(sOnePart, 'width', '0'))	// 原图宽度
      iImgHeight = parseInt(GetOnePara(sOnePart, 'height', '0'))	// 原图高度
      iRows = parseInt(GetOnePara(sOnePart, 'rows', '0'))		// 图像占用的行数
      iCols = parseInt(GetOnePara(sOnePart, 'cols', '0'))			// 图像占用的列数
      iShowWidth = iRows * iRowWidth						// 用于显示的宽度
      iShowHeight = iShowWidth * iImgHeight / iImgWidth // 用于显示的高度(通过高宽比例进行计算)
      iShowHeight = iCols * iFontSize * 1.3 			// 用于显示的高度(通过字符数进行计算)
      objImg = document.createElement('div')
      objDivRow.appendChild(objImg)
      objImg.className = 'div_insert'
      objImg.width = iImgWidth
      objImg.height = iImgHeight
      objImg.style.top = iDivHeight + 10
      objImg.style.left = -1 * iShowWidth + iRowWidth + 3 + 'px'
      objImg.innerHTML = '<img src=' + sCurInsetPath + sImgFn + ' width=' + (iShowWidth - 6) + ' height=' + iShowHeight + '>'
      objImg.style.position = 'absolute'
    } else if (sOnePart.indexOf('<mark') < 0) {
      if (iType < 3) {
        // 在文字外面再加上一个div，方便两列并列的文字定位
        objPart = document.createElement('div')
        objDivRow.appendChild(objPart)
        objPart.className = 'div_part'
        objPart.style.width = iRowWidth + 'px'
        iDivHeight += sOnePart.length * iPartFontSize * 1.3
      }

      var objDivPart = document.createElement('div')
      objPart.appendChild(objDivPart)

      objDivPart.className = 'div_part_words'
      sOnePart = ReplaceNotesAndZaozi(sOnePart, iType)
      sOnePart = sOnePart.replace(cTurnRed, '<font color=red>' + cTurnRed + '</font>')
      sOnePart = sOnePart.replace(cTurnRedFt, '<font color=red>' + cTurnRedFt + '</font>')
      objDivPart.innerHTML = sOnePart
      objDivPart.style.fontSize = iPartFontSize + 'px'

      if (iType < 2) {
        objDivPart.style.left = ((iDivWidth - iPartFontSize) / 2) + 'px'
        objDivPart.style.width = iPartFontSize + 'px'
      } else {
        objDivPart.style.left = iDivLeft + 'px'
        objDivPart.style.width = iDivWidth + 'px'
      }

      if (iType == 3)	// 第二小列用绝对定位
      { objDivPart.style.position = 'absolute' }
    }
  }
}

// 替换注释（在括号中的文字为注释）
function ReplaceNotesAndZaozi (sStr, iType) {
  var sRet = ''
  var sOne = ''
  var iStart = -1
  var iLen = sStr.length
  for (var i = 0; i < iLen; i++) {
    sOneWord = sStr.charAt(i)
    var iCode = sOneWord.charCodeAt(0)
    if (iCode >= 0xd800 && iCode <= 0xdbff) {
      i++
      sOneWord += sStr.charAt(i)
      sOneWord += '<br>'
    }
    if (sOneWord == '（') {
      iStart = 1
      sOne += '<div class="note_words">'
    } else if (sOneWord == '）') {
      if (iStart == -1) {
        var sTemp = ''

        while (sOne.length > 0 && sOne.charAt(0) == '䶻') {
          sTemp += '䶻'
          sOne = sOne.substr(1)
        }
        sOne = sTemp + '<div class="note_words">' + sOne + '</div>'
      } else {
        sOne = sOne + '</div>'
      }
      sRet += sOne
      sOne = ''
    } else {
      sOne += sOneWord
    }
  }
  sRet += sOne

  var sZaoZiClass
  if (iType == 2 || iType == 3) { sZoaZiClass = 'zaozi_small' } else { sZoaZiClass = 'zaozi_big' }
  var iPos
  sStr = sRet
  sRet = ''
  while (true) {
    iPos = sStr.indexOf('★')
    if (iPos < 0) {
      sRet += sStr
      break
    }
    sRet = sRet + sStr.substr(0, iPos)
    iZaoZiCount++
    sOne = '<IMG class="' + sZoaZiClass + '" src="' + sCurInsetPath + sJustFn + 'z' + GetZaoZiNumber(iZaoZiCount) + '.jpg">'
    sRet += sOne
    sStr = sStr.substr(iPos + 1)
  }
  return sRet
}

// 根据造字编号获取造字最后一位或两位的字符串
function GetZaoZiNumber (iNumber) {
  var sChar1 = ''
  var sChar2 = ''
  if (iNumber > 26) {
    iNumber = iNumber - 26
    sChar1 = 'Z'
    sChar2 = String.fromCharCode(iNumber + 64)
  } else if (iNumber > 52) {
    iNumber = iNumber - 52
    sChar1 = 'ZZ'
    sChar2 = String.fromCharCode(iNumber + 64)
  } else {
    sChar1 = String.fromCharCode(iNumber + 64)
  }
  return sChar1 + sChar2
}
// 显示顶部或底部图像
function ShowHideImage (sId) {
  objDiv = document.getElementById(sId)
  if (objDiv.style.visibility == 'hidden') { objDiv.style.visibility = 'visible' } else { objDiv.style.visibility = 'hidden' }
}

// 生成天头地脚图像
function CreateImage (objDiv, sCode, sName, sImgStr, iBtnLeft, iBtnTop, iImgLeft, iImgTop) {
  if (sImgStr.length == 0) { return }
  // 增加按键DIV
  objBtn = document.createElement('div')
  objBtn.style.left = iBtnLeft + 'px'
  objBtn.style.top = iBtnTop + 'px'
  objBtn.style.position = 'absolute'
  objBtn.innerHTML = "<a class=\"btn_ttdjimg\" href=\"javascript:ShowHideImage(\'id_" + sCode + "\')\">" + sName + '</a>&nbsp;'
  objDiv.appendChild(objBtn)

  sImgFn = GetOnePara(sImgStr, 'src', '')
  iImgWidth = eval(GetOnePara(sImgStr, 'width', '0'))		// 原图宽度
  iImgHeight = eval(GetOnePara(sImgStr, 'height', '0'))	// 原图高度

  // 增加图像DIV
  objImg = document.createElement('div')
  objImg.id = 'id_' + sCode
  objDiv.appendChild(objImg)
  objImg.width = objDiv.style.width + 'px'
  objImg.height = iImgHeight
  var iShowTop
  if (iImgTop == 0) {
    iImgHeight = parseInt(objDiv.style.width) * iImgHeight / iImgWidth
    iShowTop = iImgTop - iImgHeight

    if (iShowTop < -200) { iShowTop = -200 }
  } else {
    iShowTop = iImgTop
  }

  objImg.style.top = iShowTop + 'px'
  objImg.style.left = iImgLeft + 'px'
  objImg.style.visibility = 'hidden'
  objImg.innerHTML = '<img src=' + sCurInsetPath + sImgFn + " width=\"99%\" title=\"在图像单击鼠标左键隐藏！\" onclick=ShowHideImage(\'id_" + sCode + "\')>"
  objImg.style.position = 'absolute'
  objImg.style.zIndex = 200
}

// 上一页
function ChangePrevPage () {
  if (index2 > 0) {
    index2 -= 1
    parent.$('.nav_2:eq(' + index2 + ')').addClass('on').siblings('.nav_2').removeClass('on') // 左侧目录树高亮显示
    goMarkArt(index2 + 1, nOpenFc)
  } else {
    alert('已经是第一页！')
  }
}
// 下一页
function ChangeNextPage () {
  if (index2 < nLast - 1) {
    index2 += 1
    parent.$('.nav_2:eq(' + index2 + ')').addClass('on').siblings('.nav_2').removeClass('on') // 左侧目录树高亮显示
    goMarkArt(index2 + 1, nOpenFc)
  } else {
    alert('已经是最后一页！')
  }
}

// 对字符大小进行缩放操作
// iSize大于0表示放大，小于0表示缩小，等于0表示还原
function ChangeWordSize (iSize) {
//   if (g_nClicked == 4) // PDF图像
//   {
//     if (iSize < 0) { iSize = -8 }
//     if (iSize > 0) { iSize = 8 }

//     if (iSize == 0) {
//       Fonz_scale = 0
//       g_nImgHeight = g_nSrcImgHeight// +10;
//     } else { Fonz_scale += iSize }
//     if (iSize < 0) { iSize = -8 }
//     if (iSize > 0) { iSize = 8 }
//     g_nImgHeight = g_nImgHeight * (100 + iSize) / 100
//     document.all.iHtmPdf.height = g_nImgHeight + 170
//   } else
  if (g_nClicked == 1 || g_nClicked == -1 && (iBZD == 1 || iBZD == 2 || iBZD == 3)) // 原文图像
    	{
    		var bigimg = document.getElementById('id_pic')
    var width = bigimg.width
    var height = bigimg.height

	        if (iSize == 0) {
      width = g_nSrcImgWeight
      height = g_nSrcImgHeight
    } else {
		        width = width * (100 + iSize) / 100
		        height = height * (100 + iSize) / 100
		    }
	        document.getElementById('id_pic').height = height
	        document.getElementById('id_pic').width = width
	        // $(".aticle_js_pic").width((width)+ "px");
		    // $(".aticle_js_pic").height((height)+ "px");
    	} else if (g_nClicked == 2) { // 竖版文字
    	ChangeWordSize2(iSize)
  } else if (g_nClicked == 0) { // 横版文字
    	var obj = document.getElementById('iHtmH').contentWindow
    var ifmObj = obj.document.getElementById('hbwz')
    var iFontsize = ifmObj.style.fontSize.replace('px', '')
    var iFontsizeNew = iFontsize * (100 + iSize) / 100
    if (iSize == 0) { iFontsizeNew = 18 }
    ifmObj.style.fontSize = iFontsizeNew + 'px'
  } else {
    if (iRowWidth < 25 && iSize < 0) {
      alert('字太小了，看不清楚，请不要再缩小了！')
      return
    }
    if (iRowWidth > 120 && iSize > 0) {
      alert('字太大了，屏幕放不下，请不要再放大了！')
      return
    }
    if (iSize == 0) {
      Fonz_scale = 0
    } else {
      Fonz_scale += iSize
    }
    objDivRebuildPage = document.getElementById('sDivId')
    $(objDivRebuildPage).empty() // 清空原来的内容
    ShowOnePage(objDivRebuildPage) // 重新显示
  }
  // alert(g_nImgHeight+"/"+parseFloat(document.getElementById("pinglun").style.marginTop.replace("px","")))
  nn = 0
  if (iSize < 0) { nn = -1 }
  if (iSize > 0) { nn = 1 }
  g_nSize = nn
  if (document.getElementById('keyword').style.marginTop == '') {
	    document.getElementById('keyword').style.marginTop = '25px'
	    document.getElementById('pinglun').style.marginTop = '25px'
	    document.getElementById('login-footer').style.paddingTop = '0px'
  }
  if (g_nSize == 1 && g_nClicked != 0) {
    if (g_nClicked == 4) {
      document.getElementById('keyword').style.marginTop = (parseFloat(document.getElementById('keyword').style.marginTop.replace('px', '')) + g_nSize * 52.2) + 'px'
      document.getElementById('pinglun').style.marginTop = (parseFloat(document.getElementById('pinglun').style.marginTop.replace('px', '')) + g_nSize * 52.2 - 52.2) + 'px'
      document.getElementById('login-footer').style.paddingTop = (parseFloat(document.getElementById('login-footer').style.paddingTop.replace('px', '')) + g_nSize * 52.2 - 52.2) + 'px'
    } else {
      document.getElementById('keyword').style.marginTop = (parseFloat(document.getElementById('keyword').style.marginTop.replace('px', '')) + g_nSize * 52.2) + 'px'
      document.getElementById('pinglun').style.marginTop = (parseFloat(document.getElementById('pinglun').style.marginTop.replace('px', '')) + g_nSize * 52.2 - 52.2) + 'px'
      document.getElementById('login-footer').style.paddingTop = (parseFloat(document.getElementById('login-footer').style.paddingTop.replace('px', '')) + g_nSize * 52.2 - 52.2) + 'px'
    }
  }
  if (g_nSize == -1 && g_nClicked != 0) {
    if (g_nClicked == 4) {
      document.getElementById('keyword').style.marginTop = (parseFloat(document.getElementById('keyword').style.marginTop.replace('px', '')) + g_nSize * 56.2) + 'px'
      document.getElementById('pinglun').style.marginTop = (parseFloat(document.getElementById('pinglun').style.marginTop.replace('px', '')) + g_nSize * 56.2 + 56.2) + 'px'
      document.getElementById('login-footer').style.paddingTop = (parseFloat(document.getElementById('login-footer').style.paddingTop.replace('px', '')) + g_nSize * 56.2 + 56.2) + 'px'
    } else {
      document.getElementById('keyword').style.marginTop = (parseFloat(document.getElementById('keyword').style.marginTop.replace('px', '')) + g_nSize * 52.2) + 'px'
      document.getElementById('pinglun').style.marginTop = (parseFloat(document.getElementById('pinglun').style.marginTop.replace('px', '')) + g_nSize * 52.2 + 52.2) + 'px'
      document.getElementById('login-footer').style.paddingTop = (parseFloat(document.getElementById('login-footer').style.paddingTop.replace('px', '')) + g_nSize * 52.2 + 52.2) + 'px'
    }
  }
  if (g_nSize == 0 && g_nClicked != 0) {
    if (g_nClicked == 4) {
      document.getElementById('keyword').style.marginTop = '65px'
      document.getElementById('pinglun').style.marginTop = '25px'
      document.getElementById('login-footer').style.paddingTop = '0px'
    } else {
      document.getElementById('keyword').style.marginTop = '25px'
      document.getElementById('pinglun').style.marginTop = '25px'
      document.getElementById('login-footer').style.paddingTop = '0px'
    }
  }
  // alert(g_nImgHeight+"/"+document.getElementById("keyword").style.marginTop+"/"+document.getElementById("pinglun").style.marginTop+"/"+document.getElementById("login-footer").style.paddingTop)
}

// 将一行的内容根据标记进行拆分，结果保存到数组中
function SplitOneLine (arrayLine, sStr) {
  var iPos
  var sOnePart
  while (sStr.length > 0) {
    iPos = sStr.indexOf('<')
    if (iPos < 0) {
      arrayLine[arrayLine.length] = sStr
      break
    }

    sOnePart = sStr.substr(0, iPos)
    sStr = sStr.substr(iPos)
    if (sOnePart.length > 0) {
      arrayLine[arrayLine.length] = sOnePart
    }
    iPos = sStr.indexOf('>')
    if (iPos < 0) {
      arrayLine[arrayLine.length] = sStr
      break
    }
    sOnePart = sStr.substr(0, iPos + 1)
    sStr = sStr.substr(iPos + 1)

    if (sOnePart == '</mark>') { sOnePart = '' }

    if (sOnePart.length > 0) {
      arrayLine[arrayLine.length] = sOnePart
    }
  }
}

// 获取一行的长度
function GetOneLineLen (sOneLine) {
  sOneLine = DeleteSubString(sOneLine, '<img ', '>')		// 删除插图标记
  // 删除小字的文字块
  var arrayTemp = sOneLine.split('</bl>')
  sOneLine = ''
  var i
  for (i = 0; i < arrayTemp.length; i++) {
    if (arrayTemp[i].indexOf('fs="1"') > 0) {
      ;
    } else {
      sOneLine += DeleteSubString(arrayTemp[i], '<bl ', '>')
    }
  }
  //	sOneLine=DeleteSubString(sOneLine,"<bl ",">")	//删除文字块标记
  var sThisStr = sOneLine
  sThisStr = sThisStr.replace('<mark type="select.start" kind="SELECT"></mark>', '')
  sThisStr = sThisStr.replace('<mark type="select.end"></mark>', '')
  sThisStr = sThisStr.replace('<mark type="image"></mark>', '')

  if (sThisStr.indexOf('<mark') >= 0) {
    // 重新组合串，删除标记及小字中的第二行字
    var arrayOneLine = new Array()
    SplitOneLine(arrayOneLine, sOneLine)
    sThisStr = ''
    var iType = 0
    for (i = 0; i < arrayOneLine.length; i++) {
      var sOnePart = arrayOneLine[i]

      if (sOnePart.indexOf('<mark') >= 0) {
        if (sOnePart.indexOf('type="sbr"') > 0) {
          iType = 1 // 第二列，不计入长度
        } else { iType = 0 }
        if (sOnePart.indexOf('type="small.end"') > 0) { iType = 0 }
        sOnePart = ''
      }

      if (iType == 1) { sOnePart = '' } // 第二列，不计入长度
      sThisStr += sOnePart
    }
  }

  return sThisStr.length
} // 获取一行最多可以容纳的字数（新）
function GetOneLinevs (sOneLine) {
  var sLines = 0, itxtButton = -1
  sOneLine = DeleteSubString(sOneLine, '<img ', '>')		// 删除插图标记
  var indexline = sOneLine.indexOf('[IMG')
  if (indexline > 0) { return 0 }
  // 删除小字的文字块
  var arrayTemp = sOneLine.split('</bl>')
  sOneLine = ''
  var i
  for (i = 0; i < arrayTemp.length; i++) {
    if (aspectratio <= 1) {
      sOneLine = DeleteSubString(arrayTemp[i], '<bl ', '>')
      // 小字处理
      var sFontsize = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      // 括号的处理
      if (sOneLine.indexOf('（') > -1) {
        sOneLine = sOneLine.replace('（', '')
      }
      if (sOneLine.indexOf('）') > -1) {
        sOneLine = sOneLine.replace('）', '')
      }
      var sOneArrary = SplitStringToArray(sOneLine)
      //
      var sLinesTemp = ''
      if (sFontsize == 1) {
        sLinesTemp = sOneArrary.length * 0.65 + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      } else {
        sLinesTemp = sOneArrary.length + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      }
      // 书名页的处理
      var sFtsize = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var sFtsizeNo = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      sFtsizeNo = sFtsizeNo / 2
      if (sFtsize == 3) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iSMScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      } else if (sFtsize == 9) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iBTScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      }
      if (Math.ceil(sLinesTemp) > sLines) { sLines = sLinesTemp }
    } else {
      // 特殊处理bs
      var sTlines = Number(GetOnePara(arrayTemp[i], 'bs', '0'))
      var sTlinesde = GetOnePara(arrayTemp[i], 'bs', '0')
      var iTopSpaces = Number(GetOnePara(arrayTemp[i], 'ts', '0'))
      var iStartLineNos = parseInt(GetOnePara(arrayTemp[i], 'sl', '0'))
      var iEndLineNos = parseInt(GetOnePara(arrayTemp[i], 'el', '0'))
      var iFieldNos = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var iFontSizeNos = parseFloat(GetOnePara(arrayTemp[i], 'fs', '0'))
      itxtButton = sTlines
      if (sTlines > sLines) { sLines = sTlines }
    }
  }
  return sLines
}
// 获取一行最多可以容纳的字数
function GetOneLineLens (sOneLine) {
  var sLines = 0, itxtButton = -1
  sOneLine = DeleteSubString(sOneLine, '<img ', '>')		// 删除插图标记
  var indexline = sOneLine.indexOf('[IMG')
  if (indexline > 0) { return 0 }
  // 删除小字的文字块
  var arrayTemp = sOneLine.split('</bl>')
  sOneLine = ''
  var i
  for (i = 0; i < arrayTemp.length; i++) {
    if (aspectratio <= 1) {
      sOneLine = DeleteSubString(arrayTemp[i], '<bl ', '>')
      // 小字处理
      var sFontsize = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      // 括号的处理
      if (sOneLine.indexOf('（') > -1) {
        sOneLine = sOneLine.replace('（', '')
      }
      if (sOneLine.indexOf('）') > -1) {
        sOneLine = sOneLine.replace('）', '')
      }
      var sOneArrary = SplitStringToArray(sOneLine)
      //
      var sLinesTemp = ''
      if (sFontsize == 1) {
        sLinesTemp = sOneArrary.length * 0.65 + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      } else {
        sLinesTemp = sOneArrary.length + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      }
      // 书名页的处理
      var sFtsize = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var sFtsizeNo = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      sFtsizeNo = sFtsizeNo / 2
      if (sFtsize == 3) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iSMScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      } else if (sFtsize == 9) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iBTScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      }
      if (Math.ceil(sLinesTemp) > sLines) { sLines = sLinesTemp }
    } else {
      // 特殊处理bs
      var sTlines = Number(GetOnePara(arrayTemp[i], 'bs', '0'))
      var sTlinesde = GetOnePara(arrayTemp[i], 'bs', '0')
      var iTopSpaces = Number(GetOnePara(arrayTemp[i], 'ts', '0'))
      var iStartLineNos = parseInt(GetOnePara(arrayTemp[i], 'sl', '0'))
      var iEndLineNos = parseInt(GetOnePara(arrayTemp[i], 'el', '0'))
      var iFieldNos = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var iFontSizeNos = parseFloat(GetOnePara(arrayTemp[i], 'fs', '0'))
      itxtButton = sTlines
      if (iFontSizeNos == 2 && iFieldNos == 17 && iEndLineNos - iStartLineNos == 1 && iStartLineNos % 2 == 0) {
        // 正文大字处理
        var arrayOneLines = arrayTemp[i].split('</bl>')[0]
        arrayOneLines = DeleteSubString(arrayOneLines, '<bl ', '>')
        var sOnebk = arrayOneLines
        if (IsPagetion) {
          sOnebk = DeleteSubString(arrayOneLines, '<txt ', '>')
          while (sOnebk.indexOf('</txt>') > -1) {
            sOnebk = sOnebk.replace('</txt>', '')
          }
        }
        // 括号的处理
        while (arrayOneLines.indexOf('（') > -1) {
          arrayOneLines = arrayOneLines.replace('（', '')
        }
        while (arrayOneLines.indexOf('）') > -1) {
          arrayOneLines = arrayOneLines.replace('）', '')
        }
        var bsTlines = SplitStringToArray(arrayOneLines).length + iTopSpaces
        if (sTlinesde.indexOf('.') > -1) {
          bsTlines = sTlines
        }
        if (sTlines.toString().indexOf('.') > -1) { bsTlines = sTlines }
        sTlines = bsTlines
      }
      if (sTlines > sLines) { sLines = sTlines }
    }
  }
  return sLines
}
// 计算一行字的缩放比例;判断是否全是小字是返回true、false;
function ToItspaces (sOneLine, code) {
  var isSonFon = true // 记录是否全是小字
  var isSonFonNo = true // 记录全是大字
  var toSonspace = 0 // 记录全部小行的缩放比列
  var isSonPiaces = false //
  var sLines = 0
  var itspacesed = 0
  sOneLine = DeleteSubString(sOneLine, '<img ', '>') 		// 删除插图标记
  var indexline = sOneLine.indexOf('[IMG')
  if (indexline > 0) { return 0 }
  // 删除小字的文字块
  var arrayTemp = sOneLine.split('</bl>')
  sOneLine = ''
  var i
  for (i = 0; i < arrayTemp.length; i++) {
    if (aspectratio <= 1) {
      sOneLine = DeleteSubString(arrayTemp[i], '<bl ', '>')
      // 小字处理
      var sFontsize = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      // 括号的处理
      if (sOneLine.indexOf('（') > -1) {
        sOneLine = sOneLine.replace('（', '')
      }
      if (sOneLine.indexOf('）') > -1) {
        sOneLine = sOneLine.replace('）', '')
      }
      var sOneArrary = SplitStringToArray(sOneLine)
      //
      var sLinesTemp = ''
      if (sFontsize == 1) {
        sLinesTemp = sOneArrary.length * 0.65 + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      } else {
        sLinesTemp = sOneArrary.length + parseInt(GetOnePara(arrayTemp[i], 'ts', '0'))
      }
      // 书名页的处理
      var sFtsize = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var sFtsizeNo = parseInt(GetOnePara(arrayTemp[i], 'fs', '0'))
      sFtsizeNo = sFtsizeNo / 2
      if (sFtsize == 3) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iSMScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      } else if (sFtsize == 9) {
        sLinesTemp = (sOneArrary.length * 0.65 * sFtsizeNo * iBTScale + parseInt(GetOnePara(arrayTemp[i], 'ts', '0')))
      }
      if (Math.ceil(sLinesTemp) > sLines) { sLines = sLinesTemp }
    } else {
      if (arrayTemp[i] == '') {
        continue
      }
      // 特殊处理bs
      var sTlines = parseFloat(GetOnePara(arrayTemp[i], 'bs', '0'))
      var iTopSpaces = parseFloat(GetOnePara(arrayTemp[i], 'ts', '0'))
      var sTlinesed = GetOnePara(arrayTemp[i], 'bs', '0')
      var iTopSpacesed = GetOnePara(arrayTemp[i], 'ts', '0')
      var iStartLineNos = parseInt(GetOnePara(arrayTemp[i], 'sl', '0'))
      var iEndLineNos = parseInt(GetOnePara(arrayTemp[i], 'el', '0'))
      var iFieldNos = parseInt(GetOnePara(arrayTemp[i], 'fn', '0'))
      var iFontSizeNos = parseFloat(GetOnePara(arrayTemp[i], 'fs', '0'))
      //            //
      if ((iFieldNos == 17 && iEndLineNos - iStartLineNos == 0) && iFontSizeNos == 1) {

      } else {
        isSonFon = false
      }
      //
      var replicLine = 0 // 一个括号5个像素（累加）
      var arrayOneLines = arrayTemp[i].split('</bl>')[0]
      arrayOneLines = DeleteSubString(arrayOneLines, '<bl ', '>')
      var sOnebk = arrayOneLines
      if (iFontSizeNos == 2 && iFieldNos == 17 && iEndLineNos - iStartLineNos == 1 && iStartLineNos % 2 == 0) {
        // 正文大字处理
        if (IsPagetion) {
          sOnebk = DeleteSubString(arrayOneLines, '<txt ', '>')
          while (sOnebk.indexOf('</txt>') > -1) {
            sOnebk = sOnebk.replace('</txt>', '')
          }
        }
        // 括号的处理
        while (arrayOneLines.indexOf('（') > -1) {
          arrayOneLines = arrayOneLines.replace('（', '')
          replicLine += 3
        }
        while (arrayOneLines.indexOf('）') > -1) {
          arrayOneLines = arrayOneLines.replace('）', '')
          replicLine += 3
        }
      }
      // 比例换算：
      var isboTop = false
      // 处理大字显示是否变瘦问题aspectratio
      if ((iFieldNos == 17 && iEndLineNos - iStartLineNos == 1 && iStartLineNos % 2 == 0)) {
        if (sTlinesed.indexOf('.') > -1) {
          isboTop = true
        } else if (iTopSpacesed.indexOf('.') > -1) {
          isboTop = true
        }
      } else {
        isboTop = true
      }
      if (!isboTop) {
        sTlines = SplitStringToArray(arrayOneLines).length + iTopSpaces
      }
      var itxtCount = sTlines - iTopSpaces
      // 改变字体的长度（字变瘦）
      if (itxtCount > 0 && sTlines > 0 && aspectratio > 1.0) {
        //
        var XeHeightts = (iFontSize * 1.2)
        // 小字处理
        if (iFontSizeNos == 1) { XeHeightts = (iFontSize * 0.65) * 1.2 }
        // 小小字的处理
        if (iFieldNos == 0) { XeHeightts = ((iFontSize * 0.7) * 0.6) * 1.2 }
        // 小字三行的处理
        if (iFieldNos == 10) { XeHeightts = iFontSize * 0.5 * 1.4 }
        var itxtCountlength = SplitStringToArray(arrayOneLines).length
        // itxtCountlength = SplitStringToArray(sOnebk).length + iTopSpace;
        var itextSpaces = aspectHeight
        itspacesed = (itextSpaces * itxtCount) / (XeHeightts * itxtCountlength + replicLine)
        // 处理bs小于实际字数
        if (aspectHeight > 0 && sTlines < itxtCountlength - 3) {
          itextSpaces = aspectHeight
          itspacesed = (aspectHeight * itxtCount) / (XeHeightts * itxtCountlength)
        } else {
          isSonPiaces = true
        }
        // 记录小字的缩放比例tocountses = 0, tocountsNo  txMaxSize
        if (iFontSizeNos == 1 && iFieldNos == 17 && iEndLineNos - iStartLineNos == 0) {
          if (itxtCount >= tocountses) {
            if (toSonspace == 0) {
              toSonspace = itspacesed
              tocountses = itxtCount
            } else if (toSonspace < itspacesed) {
              toSonspace = itspacesed
              tocountses = itxtCount
            }
          } else {
            if (toSonspace == 0) {
              toSonspace = itspacesed
              tocountses = itxtCount
            }
          }
        }
        // 记录大字的缩放比例toArrayitspacNo
        if (iFontSizeNos == 2 && iFieldNos == 17 && iEndLineNos - iStartLineNos == 1 && iStartLineNos % 2 == 0) {
          if (itxtCount >= tocountsNo) {
            if (toArrayitspacNo == 0) {
              toArrayitspacNo = itspacesed
              aspectHeightpe = XeHeightts * toArrayitspacNo
            } else if (toArrayitspacNo < itspacesed) {
              toArrayitspacNo = itspacesed
              aspectHeightpe = XeHeightts * toArrayitspacNo
            }
            tocountsNo = itxtCount
          } else {
            if (toArrayitspacNo == 0) {
              toArrayitspacNo = itspacesed
              aspectHeightpe = XeHeightts * toArrayitspacNo
              tocountsNo = itxtCount
            }
          }
        } else {
          isSonFonNo = false
        }
      }
      if (sTlines > sLines) {
        // sLines = sTlines;
      }
    }
  }
  if (isSonPiaces) {
    if (toArrayitspaces == 0) {
      toArrayitspaces = toSonspace
    } else if (toArrayitspaces < toSonspace && toSonspace != 0) {
      toArrayitspaces = toSonspace
    }
  }
  if (isSonFon) {
    if (toArrayitspaces == 0) {
      toArrayitspaces = toSonspace
    } else if (toArrayitspaces < toSonspace && toSonspace != 0) {
      toArrayitspaces = toSonspace
    }
  }
  var isTrue = isSonFon
  if (code == '2') {
    isTrue = isSonFonNo
  }
  return isTrue
}
// 删除字符串中的一部份
function DeleteSubString (sString, sStart, sEnd) {
  var iPos
  var sLeft, sRight
  while (true) {
    iPos = sString.indexOf(sStart)
    if (iPos < 0) { break }
    sLeft = sString.substr(0, iPos)
    sRight = sString.substr(iPos)
    iPos = sRight.indexOf(sEnd)
    if (iPos < 0) { break }
    sRight = sRight.substr(iPos + sEnd.length)
    sString = sLeft + sRight
  }
  return sString
}

// 从串中获取一个参数
function GetOnePara (sString, sPara, sDefault) {
  var iPos
  var sRet = ''
  iPos = sString.indexOf(sPara + '=')
  if (iPos >= 0) {
    sRet = sString.substr(iPos + sPara.length + 1)
    iPos = sRet.indexOf(' ')
    if (iPos > 0) { sRet = sRet.substr(0, iPos) }
    iPos = sRet.indexOf('/>')
    if (iPos > 0) { sRet = sRet.substr(0, iPos) }
    iPos = sRet.indexOf('>')
    if (iPos > 0) { sRet = sRet.substr(0, iPos) }
    if (sRet.length > 0) {
      if (sRet.substr(0, 1) == '"' || sRet.substr(0, 1) == "'") { sRet = sRet.substr(1) }
    }
    if (sRet.length > 0) {
      if (sRet.substr(sRet.length - 1) == '"' || sRet.substr(sRet.length - 1) == "'") { sRet = sRet.substr(0, sRet.length - 1) }
    }
  }
  if (sRet == '') { sRet = sDefault }
  return sRet
}
// 显示书名
function AddBookName (objDivRow_Line) {
  var iHeight = objDivRow_Line.style.height
  var objBookName = document.createElement('div')
  var objFlag = document.createElement('div')
  var objPageNo = document.createElement('div')
  objBookName.className = 'div_bookname'
  objFlag.className = 'div_flag'
  objPageNo.className = 'div_pageno'
  objDivRow_Line.appendChild(objBookName)
  objDivRow_Line.appendChild(objFlag)
  objDivRow_Line.appendChild(objPageNo)

  objBookName.innerHTML = parent.cBookName
  objFlag.innerHTML = '︻'

  objBookName.style.fontSize = iFontSize * 1.2 + 'px'
  objBookName.style.left = (iRowWidth - iFontSize * 1.2) / 2 + 'px'
  objBookName.style.width = iFontSize * 1.2 + 'px'

  objFlag.style.fontSize = iRowWidth + 'px'
  objFlag.style.left = '-1px'

  objPageNo.innerHTML = GetChinesePageNo(iPageNo + 1)
  objPageNo.style.fontSize = iFontSize * 0.6 + 'px'
  objPageNo.style.left = (iRowWidth - iFontSize * 0.6) / 2 + 'px'
  objPageNo.style.width = iFontSize * 0.6 + 'px'
}
// 将数字页码转换为中文页码
function GetChinesePageNo (iPageNo) {
  var iOne, iTen, iPercent, iThousand
  iThousand = Math.floor(iPageNo / 1000)
  iPercent = Math.floor((iPageNo % 1000) / 100)
  iTen = Math.floor((iPageNo % 1000 % 100) / 10)
  iOne = iPageNo % 1000 % 100 % 10
  var sOne, sTen, sPercent, sThousand
  sThousand = ToChinese(iThousand)
  sPercent = ToChinese(iPercent)
  sTen = ToChinese(iTen)
  sOne = ToChinese(iOne)
  var sRet = ''
  if (iThousand > 0) { sRet = sThousand + '千' }
  if (iPercent > 0) { sRet = sRet + sPercent + '百' } else { sRet = sRet + sPercent }
  if (iTen > 0) { sRet = sRet + sTen + '十' } else { sRet = sRet + sTen }
  if (iOne > 0) { sRet = sRet + sOne }

  // 删除前面的零
  while (sRet.substr(0, 1) == '零') { sRet = sRet.substr(1) }
  // 删除后面的零
  while (sRet.substr(sRet.length - 1) == '零') { sRet = sRet.substr(0, sRet.length - 1) }
  sRet = sRet.replace('零零', '零')
  return sRet
}
// 将数字转换为中文
function ToChinese (iNo) {
  var sChinese = '零一二三四五六七八九'
  return sChinese.substr(iNo, 1)
}

String.prototype.myReplace = function (f, e) { // 把f替换成e
  var reg = new RegExp(f, 'g') // 创建正则RegExp对象
  return this.replace(reg, e)
}

// 放大缩小
function ChangeFonts () {
  var iSize = Fonz_scale
  if (iSize != 0) {
    iRowWidth = iRowWidth * (100 + iSize) / 100
    iFontSize = iFontSize * (100 + iSize) / 100
    // 图像的放大缩小
    var img_divps = document.getElementById('img_pic')
    xImageWidth = xImageWidth * (100 + iSize) / 100
    xImageHeight = ItextHeightpages * (100 + iSize) / 100
    //
    ItextHeightpages = ItextHeightpages * (100 + iSize) / 100
    ItextHeightpage = ItextHeightpage * (100 + iSize) / 100
    ItextToppage = ItextToppage * (100 + iSize) / 100
    /*
        if (iRowWidth>80)
        iRowWidth=80;
        if (iRowWidth<20)
        iRowWidth=20;
        if (iFontSize>40)
        iFontSize=40;
        if (iFontSize<20)
        iFontSize=20;
        */
  }
  //
  fScale = iRowWidth / iOrgRowWidth
}

function findDimensions () // 函数：获取尺寸
{
  winHeight = 0
  winWidth = 0
  // 获取窗口宽度
  winWidth = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
  // 获取窗口高度
  winHeight = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight
  return winHeight
}
function findwindowHeight () {
  return window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight
}
// 获取到顶部的距离
function getElementToPageTop (el) {
  if (el.parentElement) {
    return getElementToPageTop(el.parentElement) + el.offsetTop
  }
  return el.offsetTop
}

/// //////////////////////////////
// 异体字显示方法
function IsFontExist (t) {
  var userAgent = navigator.userAgent
  if (userAgent.indexOf('Chrome') <= -1) {
    if (t == '') { return '' };
    var f = 'Copyright ? 心のsky Group'
    var s = document.createElement('span')
    s.style.fontSize = '72px'
    s.innerHTML = f
    var b = document.getElementsByTagName('body')[0]
    b.appendChild(s)
    s.style.fontFamily = f
    var w = s.offsetWidth
    var h = s.offsetHeight
    s.style.fontFamily = t + ',' + f
    var r = ((s.offsetWidth != w) || (s.offsetHeight != h))
    b.removeChild(s)
    return !!r
  } else {
    var r = isSupportFontFamily(t)
    return !!r
  }
}
function IsFontExistBatch (t) {
  var a = t.split('\n')
  var r = new Array()
  for (var i = 0; i < a.length; i++) {
    r[i] = IsFontExist(a[i])
  }
  return r.join('\r\n')
}

var isSupportFontFamily = function (f) {
  //    f是要检测的字体
  if (typeof f !== 'string') {
    return false
  }
  //    h是基础字体
  var h = 'Arial'
  if (f.toLowerCase() == h.toLowerCase()) {
    return true
  }
  //    设置一个检测的字符A,看他是否支持f字体
  var e = 'a'
  var d = 100
  var a = 100,
    i = 100
  var c = document.createElement('canvas')
  var b = c.getContext('2d')
  c.width = a
  c.height = i
  b.textAlign = 'center'
  b.fillStyle = 'black'
  b.textBaseline = 'middle'
  var g = function (j) {
    b.clearRect(0, 0, a, i)
    //        字体是传入的j,或者是默认的h
    b.font = d + 'px ' + j + ', ' + h
    b.fillText(e, a / 2, i / 2)
    //        获取所有的canvas图片信息
    var k = b.getImageData(0, 0, a, i).data
    //        k调用数组的 filter方法,筛选符合条件的。改变原数组。
    return [].slice.call(k).filter(function (l) {
      return l != 0
    })
  }
  //    返回结果,如果h默认字体和输入待检测字体f.通过g函数检测得到的字符串不一致,说明自提生效
  return g(h).join('') !== g(f).join('')
}
// 调用
function readyFont () {
  var pageFonts = 'div_block_bigzw|div_block_smallzw|div_block_bookname|div_block_imgbt|div_block_title|div_block_imgsm'
  var t = IsFontExist('Sun-ExtA')
  var t1 = IsFontExist('HanaMinA')
  if (t == false && t1 == false) {
    setFontSun(pageFonts, 'CjkSun,CjkComp')
    // document.getElementById("smysm").style.fontFamily = "CjkSun,CjkComp";
  } else if (t == true && t1 == false) {
    setFontSun(pageFonts, 'Sun-ExtA,CjkComp')
    // document.getElementById("smysm").style.fontFamily = "Sun-ExtA,CjkComp";
  } else if (t == false && t1 == true) {
    setFontSun(pageFonts, 'CjkSun,HanaMinA')
    // document.getElementById("smysm").style.fontFamily = "CjkSun,HanaMinA";
  } else {
    setFontSun(pageFonts, 'Sun-ExtA,HanaMinA')
    // document.getElementById("smysm").style.fontFamily = "Sun-ExtA,HanaMinA";
  }
}
function setFontSun (fonts, fontName) {
  fonts = fonts.split('|')
  for (var i = 0; i < fonts.length; i++) {
    var fontstsring = fonts[i]
    var docufonts = $('.' + fontstsring)
    if (docufonts.length > 0) {
      docufonts.css('fontFamily', fontName)
    }
  }
}
function getXMLImage (sOneWord) {
  var httpRequest = new XMLHttpRequest()// 第一步：建立所需的对象
  let url = '/retrieve/page/getXMLImage?path=' + sOneWord
  httpRequest.open('GET', url, true)// 第二步：打开连接  将请求参数写在url中  ps:"http://localhost:8080/rest/xxx"
  httpRequest.send()// 第三步：发送请求  将请求参数写在URL中
  /**
         * 获取数据后的处理程序
         */
  httpRequest.onreadystatechange = function () {
    if (httpRequest.readyState == 4 && httpRequest.status == 200) {
      var json = httpRequest.responseText// 获取到json字符串，还需解析
      const binaryData = []
      binaryData.push(json)
      const url2 = window.URL.createObjectURL(
        new Blob(binaryData, { type: 'image/jpg' })
      )
      return url2
    }
  }
}
module.exports = {
  loadXMLPages, ParseXml, ChangeWordSize
}



// WEBPACK FOOTER //
// ./src/assets/showvpage22.js